import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getBussinessData } from "../../store/actions/action";
import {
  MdEdit,
  MdSettings,
  MdStore,
  MdReceipt,
  MdAttachMoney,
  MdShoppingCart,
  MdLocalShipping,
  MdPalette,
  MdFormatColorFill,
  MdWidgets,
  MdPreview,
  MdRestartAlt,
  MdImage,
  MdWallpaper,
  MdPhotoSizeSelectActual,
  MdHome,
  MdClose,
  MdCheck,
  MdVisibility,
  MdVisibilityOff,
  MdPersonOutline,
  MdQrCode,
  MdReviews,
  MdWarning,
} from "react-icons/md";
import { getAllOrders, updateOrder, getOrderDetails } from "../../services/order.service";
import { getEmployee } from "../../services/employee.service";
import { assignOrderDeliveryTask } from "../../services/task.service";
import { toast } from "react-toastify";
import { createSale } from "../../services/sale.service";
import { getBusiness, updateBussinessData } from "../../services/auth.service";
import {
  getAvailableCarriers,
  trackShipment,
  getDeliveryDetails,
  getShippingConfig,
} from "../../services/logistic.service";
import { storeSettingsService } from "../../services/storeSettings.service";
import { pushProductsToMetaService } from "../../services/inventory.service";
import "react-image-crop/dist/ReactCrop.css";
import {
  useReviewSettings,
  ReviewSettingsPanel,
} from "../online-store/storeSetting/ReviewSettings";
import {
  allPredefinedThemes,
  layoutOptions,
  buttonStyles,
  fontOptions,
} from "../../helpers/csshelper";
import { QRCodeModal } from "./storeSetting/qrCodeModel";
import { LayoutPreviewCard } from "./storeSetting/layout";
import { CropModal } from "./storeSetting/cropModel";
import { getLandingPagePath } from "./storefrontPaths";
import { getStorefrontThemePreset } from "./themeTemplates/storefrontThemePresets";
import Fiftyfour from "../../assets/pexels-cottonbro-6114597.jpg";
import Fiftyfive from "../../assets/pexels-cottonbro-6114597.jpg";
import Fiftysix from "../../assets/pexels-boris-pavlikovsky-5498382.jpg";
import FiftySeven from "../../assets/pexels-rdne-7563560.jpg";
import Fiftyeight from "../../assets/pexels-anna-nekrashevich-8534381.jpg";
import Fiftynine from "../../assets/pexels-anna-nekrashevich-8534233.jpg";
import SIxty from "../../assets/pexels-gaurav-kumar-1281378-18488298.jpg";
import { getCurrencySymbol } from "../../components/common/utlity/options";
import { t } from "i18next";
import { FeaturedSectionOptions } from "../../components/common/utlity/options";
import { Menu } from "@headlessui/react";
import {
  getBusinessTypeDefaultTheme,
  shouldUseBusinessDefaultTheme,
} from "./themeTemplates/businessThemeDefaults";
function ModalComponent({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "max-w-lg",
}) {
  if (!open) return null;
  return (
    <div className='fixed z-40 inset-0 bg-black/40 dark:bg-black/70 flex items-center justify-center backdrop-blur-sm animate-fadeIn'>
      <div
        className={`bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 rounded-2xl shadow-2xl w-full ${maxWidth} mx-4 overflow-hidden animate-scaleIn`}
      >
        <div className='px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-gray-800 dark:to-gray-900'>
          <div className='flex items-center justify-between'>
            <h2 className='text-xl font-bold text-gray-800 dark:text-white'>
              {title}
            </h2>
            <button
              onClick={onClose}
              className='text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white text-2xl font-bold transition-colors'
            >
              &times;
            </button>
          </div>
        </div>

        <div className='px-6 py-4 bg-white dark:bg-gray-900 max-h-[80vh] overflow-y-auto'>
          {children}
        </div>

        {actions && (
          <div className='px-6 py-3 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-end gap-3 rounded-b-2xl'>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
function PreAddedImageGallery({ images, onSelect, isSelected }) {
  const preAddedImages = [
    { id: "fiftyfour", src: Fiftyfour, name: "Modern Workspace" },
    { id: "fiftyfive", src: Fiftyfive, name: "Professional Setup" },
    { id: "fiftysix", src: Fiftysix, name: "Elegant Interior" },
    { id: "fiftyseven", src: FiftySeven, name: "Creative Space" },
    { id: "fiftyeight", src: Fiftyeight, name: "Minimal Design" },
    { id: "fiftynine", src: Fiftynine, name: "Cozy Environment" },
    { id: "sixty", src: SIxty, name: "Natural Light" },
  ];

  return (
    <div className='space-y-4'>
      <h5 className='text-lg font-semibold text-gray-800 mb-3'>
        Pre-added Banner Images
      </h5>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {preAddedImages.map((image) => (
          <div
            key={image.id}
            className={`relative rounded-xl overflow-hidden border-2 cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
              isSelected?.id === image.id
                ? "border-blue-500 ring-2 ring-blue-200"
                : "border-gray-200 hover:border-blue-300"
            }`}
            onClick={() => onSelect(image)}
          >
            <img
              src={image.src}
              alt={image.name}
              className='w-full h-32 object-cover'
            />
            <div className='absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2'>
              <p className='text-white text-xs font-medium truncate'>
                {image.name}
              </p>
            </div>
            {isSelected?.id === image.id && (
              <div className='absolute top-2 right-2 bg-blue-500 text-white rounded-full p-1'>
                <MdCheck size={16} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
function LogisticsStatusBadge({ order }) {
  if (!order?.logistics) {
    return (
      <span className='px-2 py-1 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 border border-gray-200 dark:border-gray-700'>
        Not Shipped
      </span>
    );
  }

  const status = order.logistics.status || "pending";
  const statusColors = {
    pickup_scheduled:
      "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800",
    in_transit:
      "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-800",
    out_for_delivery:
      "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-800",
    delivered:
      "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800",
    pending:
      "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800",
  };

  const statusText = {
    pickup_scheduled: "Pickup Scheduled",
    in_transit: "In Transit",
    out_for_delivery: "Out for Delivery",
    delivered: "Delivered",
    pending: "Pending",
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium border ${statusColors[status] || "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700"}`}
    >
      {statusText[status] || "Unknown"}
    </span>
  );
}

export default function OnlineStoreOrdersPage() {
  const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [delaySlotError, setDelaySlotError] = useState("");
  const [assignmentDialogOrder, setAssignmentDialogOrder] = useState(null);
  const [returnConfirmDialogOpen, setReturnConfirmDialogOpen] = useState(false);
  const [returnOrderToConfirm, setReturnOrderToConfirm] = useState(null);
  const [remainingDeliverySlots, setRemainingDeliverySlots] = useState({});
  const [batchQuantities, setBatchQuantities] = useState({});
  const [batchAssignmentError, setBatchAssignmentError] = useState("");
  const [copied, setCopied] = useState(false);
  const [orders, setOrders] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [employeeDeliveryEnabled, setEmployeeDeliveryEnabled] = useState(false);
  const [showTrackOrderButton, setShowTrackOrderButton] = useState(true);
  const [orderAssignees, setOrderAssignees] = useState({});
  const [assigningOrderId, setAssigningOrderId] = useState("");
  const { businessName: urlBusinessName, bussinessUuid } = useParams();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [cashOnDeliveryEnabled, setCashOnDeliveryEnabled] = useState(true);
  const params = { search, page, limit };
  const [deliveryDetails, setDeliveryDetails] = useState(null);
  const [carriers, setCarriers] = useState([]);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [storeTheme, setStoreTheme] = useState(null);
  const [storeBanner, setStoreBanner] = useState(null);
  const [layoutSettings, setLayoutSettings] = useState(null);
  const [loadingSettings, setLoadingSettings] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isB2BMode = localStorage.getItem("b2b_Price") === "true";
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [resolvedBusinessName, setResolvedBusinessName] = useState("");
  const business = useSelector((state) => state.bussiness.business);
// Add with other state declarations in OnlineStoreOrdersPage component
const [showCallButton, setShowCallButton] = useState(true);
const [showWhatsappButton, setShowWhatsappButton] = useState(true);
const [callPhoneNumber, setCallPhoneNumber] = useState('');
const [whatsappNumber, setWhatsappNumber] = useState('');
const [whatsappMessage, setWhatsappMessage] = useState('Hi! I am interested in your products.');
  useEffect(() => {
    if (bussinessUuid) {
      dispatch(getBussinessData(bussinessUuid));
    }
  }, [dispatch, bussinessUuid]);

  useEffect(() => {
    let isMounted = true;

    const loadBusinessName = async () => {
      if (!bussinessUuid) return;

      try {
        const response = await getBusiness(bussinessUuid);
        const nextBusinessName = response?.data?.businessName || "";

        if (isMounted && nextBusinessName) {
          setResolvedBusinessName(nextBusinessName);
        }
      } catch (_error) {}
    };

    loadBusinessName();

    return () => {
      isMounted = false;
    };
  }, [bussinessUuid]);
const isOrderPending = (order) => {
  const pendingStatuses = ["Pending Review", "Pending Verification"];
  const needsManualReview = order?.riskAssessment?.finalAction === "manual_review" ||
                           order?.riskAssessment?.flaskAction === "manual_review";
  
  return pendingStatuses.includes(order?.orderStatus) || needsManualReview;
};
  const displayBusinessName =
    urlBusinessName || resolvedBusinessName || business?.businessName || "";
  const [activeSettingsTab, setActiveSettingsTab] = useState("general");
  const [bannerType, setBannerType] = useState("image");
  const [bannerColor, setBannerColor] = useState("#4f46e5");
  const [previewBannerImage, setPreviewBannerImage] = useState(null);
  const [selectedBannerFile, setSelectedBannerFile] = useState(null);
  const [customTheme, setCustomTheme] = useState(null);
  const [activeLayout, setActiveLayout] = useState("fullscreen-banner");
  const [activeLayoutCategory, setActiveLayoutCategory] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [selectedPreAddedImage, setSelectedPreAddedImage] = useState(null);
  const [bannerImagePreview, setBannerImagePreview] = useState("");
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const storeUrl = `${window.location.origin}${getLandingPagePath({
    businessName: displayBusinessName,
    bussinessUuid,
  })}/`;
  const [metaLoading, setMetaLoading] = useState(false);
  const [metaActionLoading, setMetaActionLoading] = useState(false);
  const [metaCatalogSyncing, setMetaCatalogSyncing] = useState(false);
  const [metaBusinessManagerIdInput, setMetaBusinessManagerIdInput] =
    useState("");
  const [metaCatalogIdInput, setMetaCatalogIdInput] = useState("");
  const [metaStatus, setMetaStatus] = useState({
    enabled: false,
    autoSyncProducts: false,
    businessManagerName: "",
    catalogName: "",
    instagramUsername: "",
    lastSyncStatus: "pending",
    lastSyncError: "",
  });
  // Add this with your other state declarations
const [totalRevenue, setTotalRevenue] = useState(0);
const [totalOrdersCount, setTotalOrdersCount] = useState(0);
const [shippedOrdersCount, setShippedOrdersCount] = useState(0);

// Add this useEffect to fetch total revenue and counts
useEffect(() => {
  const fetchTotalStats = async () => {
    try {
      // Fetch all orders without pagination to calculate totals
      const allOrdersResponse = await getAllOrders(bussinessUuid, { search, page: 1, limit: 10000 });
      const allOrdersData = allOrdersResponse?.data?.data || [];
      
      // Calculate total revenue from all orders (excluding cancelled/returned)
      const total = allOrdersData
        .filter(o => !["Cancelled", "Returned", "Confirm return"].includes(o.orderStatus))
        .reduce((sum, o) => sum + (parseFloat(o?.total) || 0), 0);
      setTotalRevenue(total);
      
      // Total orders count
      setTotalOrdersCount(allOrdersData.length);
      
      // Shipped orders count (orders with logistics)
      const shipped = allOrdersData.filter(order => order.logistics).length;
      setShippedOrdersCount(shipped);
      
    } catch (error) {
      console.error("Error fetching total stats:", error);
    }
  };
  
  fetchTotalStats();
}, [bussinessUuid, search]);
  // const storeUrl = `${window.location.origin}/${displayBusinessName}/${bussinessUuid}/landingPage/`;
  const {
    reviewSettings,
    setReviewSettings,
    loadingReviewSettings,
    pendingReviewsCount,
    reviewStats,
    updateReviewSettings,
    resetToDefaults,
    refreshStats,
  // loadReviewData
  } = useReviewSettings(bussinessUuid);

  const normalizeThemeForSave = useCallback((theme) => {
    if (!theme) return null;

    const themeId = theme.themeId || theme.id || "";
    const preset = getStorefrontThemePreset({
      themeId,
      themeName: theme.themeName || theme.name,
    });

    return {
      ...theme,
      themeName: theme.themeName || theme.name,
      themeId,
      heroVariant: theme.heroVariant || preset.heroVariant,
      productVariant: theme.productVariant || preset.productVariant,
      layoutPreset: theme.layoutPreset || {
        heroVariant: preset.heroVariant,
        productVariant: preset.productVariant,
        sectionDensity: "balanced",
      },
      hideBanner:
        typeof theme.hideBanner === "boolean"
          ? theme.hideBanner
          : Boolean(preset.hideBanner),
    };
  }, []);

  const areThemesEqual = useCallback((left, right) => {
    return JSON.stringify(left || null) === JSON.stringify(right || null);
  }, []);

  const getOrderItemQuantity = useCallback(
    (item) => Math.max(0, Number(item?.cartQuantity || item?.quantity || 1)),
    [],
  );

  const getOrderItemKey = useCallback(
    (item, index) => {
      const productId = item?.productId || item?._id || "product";
      const variantId =
        item?.variantId ||
        item?.variantSku ||
        item?.variantName ||
        item?.variantBatchNumber ||
        "default";

      return `${productId}::${variantId}::${index}`;
    },
    [],
  );

  const getPartialProgressMap = useCallback(
    (order) => {
      const progress = Array.isArray(order?.partialDelivery?.itemProgress)
        ? order.partialDelivery.itemProgress
        : [];

      return progress.reduce((acc, entry) => {
        if (!entry?.itemKey) return acc;
        acc[entry.itemKey] = {
          orderedQuantity: Number(entry?.orderedQuantity || 0),
          deliveredQuantity: Number(entry?.deliveredQuantity || 0),
          pendingQuantity: Number(entry?.pendingQuantity || 0),
          lastDeliveredAt: entry?.lastDeliveredAt || null,
          nextPlannedDate: entry?.nextPlannedDate || "",
          nextPlannedTime: entry?.nextPlannedTime || "",
        };
        return acc;
      }, {});
    },
    [],
  );

  const getBatchItemRows = useCallback(
    (order) => {
      if (!order) return [];

      const progressMap = getPartialProgressMap(order);

      return (order.items || []).map((item, index) => {
        const itemKey = getOrderItemKey(item, index);
        const orderedQuantity = getOrderItemQuantity(item);
        const progressEntry = progressMap[itemKey] || null;
        const deliveredQuantity = progressEntry
          ? Math.max(0, Number(progressEntry.deliveredQuantity || 0))
          : 0;
        const pendingQuantity = progressEntry
          ? Math.max(0, Number(progressEntry.pendingQuantity || 0))
          : Math.max(0, orderedQuantity - deliveredQuantity);

        return {
          itemKey,
          productId: item?.productId || item?._id || "",
          variantId: item?.variantId || "",
          productName: item?.productName || `Item ${index + 1}`,
          variantName: item?.variantName || "",
          price: Math.max(0, Number(item?.salePrice || item?.price || 0)),
          orderedQuantity,
          deliveredQuantity,
          pendingQuantity,
          lastDeliveredAt: progressEntry?.lastDeliveredAt || null,
          nextPlannedDate: progressEntry?.nextPlannedDate || "",
          nextPlannedTime: progressEntry?.nextPlannedTime || "",
        };
      });
    },
    [getOrderItemKey, getOrderItemQuantity, getPartialProgressMap],
  );

  const getPartialDeliverySummary = useCallback(
    (order) => {
      const rows = getBatchItemRows(order);
      return rows.reduce(
        (acc, row) => {
          acc.ordered += row.orderedQuantity;
          acc.delivered += row.deliveredQuantity;
          acc.pending += row.pendingQuantity;
          return acc;
        },
        { ordered: 0, delivered: 0, pending: 0 },
      );
    },
    [getBatchItemRows],
  );

  // const isOrderFullyDeliveredForInvoice = useCallback(
  //   (order) => {
  //     if (!order) return false;

  //     const normalizedStatus = String(order?.orderStatus || "")
  //       .toLowerCase()
  //       .trim();

  //     if (normalizedStatus === "delivered") {
  //       return true;
  //     }

  //     if (order?.partialDelivery?.enabled) {
  //       const summary = getPartialDeliverySummary(order);
  //       return summary.ordered > 0 && summary.pending === 0;
  //     }

  //     return false;
  //   },
  //   [getPartialDeliverySummary],
  // );

  useEffect(() => {
    if (!assignmentDialogOrder) {
      setBatchQuantities({});
      setRemainingDeliverySlots({});
      setBatchAssignmentError("");
      return;
    }

    const nextRows = getBatchItemRows(assignmentDialogOrder);
    const nextQuantities = nextRows.reduce((acc, row) => {
      acc[row.itemKey] = "0";
      return acc;
    }, {});

    const nextRemainingSlots = nextRows.reduce((acc, row) => {
      acc[row.itemKey] = {
        date: row.nextPlannedDate || "",
        time: row.nextPlannedTime || "",
      };
      return acc;
    }, {});

    setBatchQuantities(nextQuantities);
    setRemainingDeliverySlots(nextRemainingSlots);
    setBatchAssignmentError("");
  }, [assignmentDialogOrder, getBatchItemRows]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const allOrders = await getAllOrders(bussinessUuid, params);
        const nextOrders = allOrders?.data?.data || [];
        setOrders(nextOrders);
        setOrderAssignees((prev) => {
          const next = { ...prev };
          nextOrders.forEach((order) => {
            if (!next[order.orderId] && order?.deliveryAssignment?.assignedEmployeeId) {
              next[order.orderId] = order.deliveryAssignment.assignedEmployeeId;
            }
          });
          return next;
        });
        if (allOrders?.data?.pagination) {
          setTotalPages(allOrders.data.pagination.pages);
        } else {
          setTotalPages(1);
        }
      } catch (error) {
        console.error("Error in fetchOrders:", error);
      }
    };

    fetchOrders();
  }, [bussinessUuid, search, page, limit]);

  const updateOrderInState = useCallback((updatedOrder) => {
    if (!updatedOrder?.orderId) return;

    setOrders((prev) =>
      prev.map((order) =>
        order.orderId === updatedOrder.orderId ? updatedOrder : order,
      ),
    );

    setSelectedOrder((prev) =>
      prev?.orderId === updatedOrder.orderId ? updatedOrder : prev,
    );
  }, []);

  const getSelectedEmployeeForOrder = useCallback(
    (order) =>
      orderAssignees[order?.orderId] ||
      order?.deliveryAssignment?.assignedEmployeeId ||
      "",
    [orderAssignees],
  );

  const handleAssignDeliveryTask = useCallback(
    async (order) => {
      const employeeId = getSelectedEmployeeForOrder(order);

      if (!employeeId) {
        toast.error(t("DELIVERY.SELECT_EMPLOYEE_FIRST"));
        return;
      }

      const batchRows = getBatchItemRows(order);
      const selectedBatchItems = batchRows
        .map((row) => {
          const rawValue = batchQuantities[row.itemKey];
          const requestedQuantity = Math.max(0, Number(rawValue || 0));

          if (requestedQuantity <= 0 || requestedQuantity > row.pendingQuantity) {
            return null;
          }

          return {
            itemKey: row.itemKey,
            productId: row.productId,
            variantId: row.variantId,
            productName: row.productName,
            variantName: row.variantName,
            price: row.price,
            quantity: requestedQuantity,
          };
        })
        .filter(Boolean);

      const selectedQuantityByKey = selectedBatchItems.reduce((acc, item) => {
        acc[item.itemKey] = Number(item.quantity || 0);
        return acc;
      }, {});
      const remainingSchedule = [];
      const remainingAfterCurrentBatch = batchRows.reduce((sum, row) => {
        const selectedQty = Number(selectedQuantityByKey[row.itemKey] || 0);
        const remainingForRow = Math.max(0, row.pendingQuantity - selectedQty);

        if (remainingForRow > 0) {
          const slot = remainingDeliverySlots[row.itemKey] || {};
          if (!slot?.date || !slot?.time) {
            remainingSchedule.push({
              itemKey: row.itemKey,
              productName: row.productName,
              remainingQuantity: remainingForRow,
              date: "",
              time: "",
            });
          } else {
            remainingSchedule.push({
              itemKey: row.itemKey,
              productName: row.productName,
              remainingQuantity: remainingForRow,
              date: slot.date,
              time: slot.time,
            });
          }
        }

        return sum + remainingForRow;
      }, 0);

      if (!selectedBatchItems.length) {
        const nextError = t("DELIVERY.SELECT_VALID_QUANTITY");
        setBatchAssignmentError(nextError);
        toast.error(nextError);
        return;
      }

      if (
        remainingAfterCurrentBatch > 0 &&
        remainingSchedule.some((entry) => !entry.date || !entry.time)
      ) {
        const nextError =
          t("DELIVERY.SELECT_NEXT_SCHEDULE");
        setBatchAssignmentError(nextError);
        toast.error(nextError);
        return;
      }

      try {
        setAssigningOrderId(order.orderId);
        setBatchAssignmentError("");
        const response = await assignOrderDeliveryTask(
          bussinessUuid,
          order.orderId,
          {
            employeeId,
            batchPlan: {
              batchId: `batch-${Date.now()}`,
              items: selectedBatchItems,
              remainingSchedule,
            },
          },
        );

        if (response?.data?.order) {
          updateOrderInState(response.data.order);
        }

        setOrderAssignees((prev) => ({
          ...prev,
          [order.orderId]: employeeId,
        }));
        setAssignmentDialogOrder(null); 
        toast.success(t("DELIVERY.BATCH_ASSIGNED_SUCCESS"));
      } catch (error) {
        toast.error(
          error?.response?.data?.message || t("DELIVERY.FAILED_TO_ASSIGN"),
        );
      } finally {
        setAssigningOrderId("");
      }
    },
    [
      batchQuantities,
      bussinessUuid,
      getBatchItemRows,
      getSelectedEmployeeForOrder,
      remainingDeliverySlots,
      updateOrderInState,
    ],
  );

const renderDeliveryAssignmentControls = useCallback(
  (order, compact = false) => {
    if (!employeeDeliveryEnabled) {
      return null;
    }

    // Check if order is pending
    const pendingStatuses = ["Pending Verification", "Pending Review"];
    const isPending = pendingStatuses.includes(order?.orderStatus);
    
    // const isClosedOrder = ["Cancelled", "Returned", "Delivered"].includes(
    //   order?.orderStatus,
    // );
    const isDeliveredOrder = order?.orderStatus === "Delivered";
    const isReturnedOrder = ["Returned", "Confirm return"].includes(order?.orderStatus);
    const isBlockedOrder = ["Cancelled"].includes(
      order?.orderStatus,
    );
    const assignedEmployeeName = order?.deliveryAssignment?.assignedEmployeeName;
    const summary = getPartialDeliverySummary(order);
    const hasPendingItems = summary.pending > 0;
    
    const buttonLabel = isDeliveredOrder
        ? t("DELIVERY.COMPLETED")
        : isReturnedOrder
          ? "Assign Pickup"
          : hasPendingItems
            ? t("DELIVERY.ASSIGN_BATCH")
          : assignedEmployeeName
            ? t("DELIVERY.REASSIGN")
            : t("DELIVERY.ASSIGN");

    return (
      <button
        type='button'
        onClick={() => setAssignmentDialogOrder(order)}
        disabled={
          isPending ||
          isBlockedOrder ||
          assigningOrderId === order?.orderId ||
          (!employees.length && !assignedEmployeeName)
        }
        title={
          isPending 
            ? "Order pending verification/review" 
            : assignedEmployeeName && !isDeliveredOrder && !isReturnedOrder
              ? t('DELIVERY.CURRENTLY_ASSIGNED_TO', { name: assignedEmployeeName })
              : buttonLabel
        }
        className='inline-flex items-center gap-1.5 rounded-lg border border-indigo-200 bg-indigo-50 px-2.5 py-2 text-xs font-semibold text-indigo-700 transition hover:border-indigo-300 hover:bg-indigo-100 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 dark:border-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200 dark:hover:bg-indigo-900/50 dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-500'
      >
        <MdPersonOutline size={14} />
        {assigningOrderId === order?.orderId ? "Assigning..." : buttonLabel}
      </button>
    );
  },
  [
    assigningOrderId,
    employeeDeliveryEnabled,
    employees,
    getPartialDeliverySummary,
  ],
);

  const assignmentDialogSelectedEmployeeId = assignmentDialogOrder
    ? getSelectedEmployeeForOrder(assignmentDialogOrder)
    : "";

  const assignmentDialogSelectedEmployee = employees.find(
    (employee) =>
      (employee?._id || employee?.employeeID || "") ===
      assignmentDialogSelectedEmployeeId,
  );

  const assignmentDialogAssignedEmployeeName =
    assignmentDialogOrder?.deliveryAssignment?.assignedEmployeeName || "";

  const assignmentDialogClosedOrder = ["Cancelled", "Returned", "Delivered"].includes(
    assignmentDialogOrder?.orderStatus,
  );

  const assignmentDialogBatchRows = assignmentDialogOrder
    ? getBatchItemRows(assignmentDialogOrder)
    : [];
  const assignmentDialogPendingBatchRows = assignmentDialogBatchRows.filter(
    (row) => row.pendingQuantity > 0,
  );
  const assignmentDialogSummary = assignmentDialogOrder
    ? getPartialDeliverySummary(assignmentDialogOrder)
    : { ordered: 0, delivered: 0, pending: 0 };

  useEffect(() => {
    const fetchShippingConfig = async () => {
      if (!bussinessUuid) return;

      try {
        const response = await getShippingConfig(bussinessUuid);
        const configData = response?.data?.data || response?.data || {};
        setEmployeeDeliveryEnabled(configData?.employeeDeliveryEnabled === true);
        setShowTrackOrderButton(configData?.showTrackOrderButton !== false);
      } catch (_error) {
        setEmployeeDeliveryEnabled(false);
        setShowTrackOrderButton(true);
      }
    };

    fetchShippingConfig();
  }, [bussinessUuid]);

  useEffect(() => {
    const fetchEmployees = async () => {
      if (!bussinessUuid) return;

      try {
        const response = await getEmployee(bussinessUuid, { limit: 200 });
        const nextEmployees = Array.isArray(response?.data?.data)
          ? response.data.data.filter((employee) => employee?.employeeType !== "owner")
          : [];
        setEmployees(nextEmployees);
      } catch (_error) {
        setEmployees([]);
      }
    };

    fetchEmployees();
  }, [bussinessUuid]);

useEffect(() => {
  const loadStoreSettings = async () => {
    try {
      setLoadingSettings(true);
        const response =
          await storeSettingsService.getStoreSettings(bussinessUuid);
      if (response.success) {
        const settings = response.data;
        const resolvedTheme = shouldUseBusinessDefaultTheme(settings.theme)
          ? getBusinessTypeDefaultTheme(business || {})
          : settings.theme;
        
        setStoreTheme(resolvedTheme);
        setStoreBanner(settings.bannerImage || settings.banner || null);
        setCashOnDeliveryEnabled(
          settings.checkoutSettings?.cashOnDeliveryEnabled !== false,
        );
        setLayoutSettings(settings.layout);
        setActiveLayout(settings.layout?.type || "fullscreen-banner");
        
        if (settings.storeDescription) {
          setDescription(settings.storeDescription);
        }
        
        if (settings.callAndWhatsappSettings) {
          setShowCallButton(settings.callAndWhatsappSettings.showCallButton !== false);
          setShowWhatsappButton(settings.callAndWhatsappSettings.showWhatsappButton !== false);
          setCallPhoneNumber(settings.callAndWhatsappSettings.phoneNumber || business?.phone || '');
          setWhatsappNumber(settings.callAndWhatsappSettings.whatsappNumber || business?.phone || '');
          setWhatsappMessage(settings.callAndWhatsappSettings.whatsappMessage || 'Hi! I am interested in your products.');
        } else {
          // Set default values if settings don't exist
          setShowCallButton(true);
          setShowWhatsappButton(true);
          setCallPhoneNumber(business?.phone || '');
          setWhatsappNumber(business?.phone || '');
          setWhatsappMessage('Hi! I am interested in your products.');
        }
      }
    } catch (error) {
      console.error('Error loading store settings:', error);
      toast.error("Failed to load store settings");
      
      // Set fallback defaults on error
      setShowCallButton(true);
      setShowWhatsappButton(true);
      setCallPhoneNumber(business?.phone || '');
      setWhatsappNumber(business?.phone || '');
      setWhatsappMessage('Hi! I am interested in your products.');
    } finally {
      setLoadingSettings(false);
    }
  };

  loadStoreSettings();
}, [bussinessUuid, business]);

  const loadMetaStatus = useCallback(async () => {
    if (!bussinessUuid) return;

    setMetaLoading(true);
    try {
      const response = await storeSettingsService.getMetaStatus(bussinessUuid);
      if (response?.success && response?.data) {
        const nextStatus = response.data;
        setMetaStatus(nextStatus);
        setMetaBusinessManagerIdInput(nextStatus?.businessManagerId || "");
        setMetaCatalogIdInput(nextStatus?.catalogId || "");
      }
    } catch (error) {
      console.error("Error fetching Meta status:", error);
    } finally {
      setMetaLoading(false);
    }
  }, [bussinessUuid]);

  useEffect(() => {
    loadMetaStatus();
  }, [loadMetaStatus]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const meta = params.get("meta");
    const message = params.get("message");

    if (meta === "connected") {
      toast.success("Meta account connected successfully");
      loadMetaStatus();
    }

    if (meta === "error") {
      toast.error(message || "Meta connection failed");
    }

    if (meta) {
      const cleanUrl = `${window.location.pathname}`;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, [loadMetaStatus]);

  // const handleConnectMeta = async () => {
  //   if (!bussinessUuid) return;

  //   setMetaActionLoading(true);
  //   try {
  //     const response =
  //       await storeSettingsService.getMetaConnectUrl(bussinessUuid);
  //     const connectUrl = response?.data?.connectUrl;

  //     if (!connectUrl) {
  //       throw new Error("Unable to generate Meta connect URL");
  //     }

  //     window.location.assign(connectUrl);
  //     return;
  //   } catch (error) {
  //     console.error("Error connecting Meta:", error);
  //     toast.error(
  //       error?.response?.data?.error || "Failed to connect Meta account",
  //     );
  //     setMetaActionLoading(false);
  //   }
  // };

  // const handleDisconnectMeta = async () => {
  //   if (!bussinessUuid) return;

  //   setMetaActionLoading(true);
  //   try {
  //     await storeSettingsService.disconnectMeta(bussinessUuid);
  //     await loadMetaStatus();
  //     toast.success("Meta account disconnected");
  //   } catch (error) {
  //     console.error("Error disconnecting Meta:", error);
  //     toast.error(
  //       error?.response?.data?.error || "Failed to disconnect Meta account",
  //     );
  //   } finally {
  //     setMetaActionLoading(false);
  //   }
  // };

  // const handleMetaAutoSyncToggle = async (checked) => {
  //   if (!bussinessUuid) return;

  //   setMetaActionLoading(true);
  //   try {
  //     await storeSettingsService.updateMetaConfig(bussinessUuid, {
  //       enabled: metaStatus.enabled,
  //       autoSyncProducts: checked,
  //     });
  //     setMetaStatus((prev) => ({
  //       ...prev,
  //       autoSyncProducts: checked,
  //     }));
  //     toast.success("Meta sync setting updated");
  //   } catch (error) {
  //     console.error("Error updating Meta sync setting:", error);
  //     toast.error(
  //       error?.response?.data?.error || "Failed to update Meta sync setting",
  //     );
  //   } finally {
  //     setMetaActionLoading(false);
  //   }
  // };

  // const handleSaveMetaCatalogConfig = async () => {
  //   if (!bussinessUuid) return;
  //   if (!metaCatalogIdInput?.trim()) {
  //     toast.error("Catalog ID is required");
  //     return;
  //   }

  //   setMetaActionLoading(true);
  //   try {
  //     await storeSettingsService.updateMetaConfig(bussinessUuid, {
  //       enabled: true,
  //       businessManagerId: metaBusinessManagerIdInput.trim(),
  //       catalogId: metaCatalogIdInput.trim(),
  //     });
  //     await loadMetaStatus();
  //     toast.success("Meta catalog configuration saved");
  //   } catch (error) {
  //     console.error("Error saving Meta catalog configuration:", error);
  //     toast.error(
  //       error?.response?.data?.error ||
  //         "Failed to save Meta catalog configuration",
  //     );
  //   } finally {
  //     setMetaActionLoading(false);
  //   }
  // };

  // const handlePushCatalogToMeta = async () => {
  //   if (!bussinessUuid) return;
  //   if (!metaStatus.enabled) {
  //     toast.error("Connect Meta first");
  //     return;
  //   }

  //   setMetaCatalogSyncing(true);
  //   try {
  //     const response = await pushProductsToMetaService(bussinessUuid);
  //     const syncResults = response?.data?.data || [];
  //     const successCount = syncResults.filter((item) => item.success).length;
  //     const failedCount = syncResults.length - successCount;

  //     toast.success(
  //       `Catalog upload complete. Success: ${successCount}, Failed: ${failedCount}`,
  //     );
  //     await loadMetaStatus();
  //   } catch (error) {
  //     console.error("Error uploading catalog to Meta:", error);
  //     toast.error(
  //       error?.response?.data?.error || "Failed to upload catalog to Meta",
  //     );
  //   } finally {
  //     setMetaCatalogSyncing(false);
  //   }
  // };

  useEffect(() => {
    const fetchCarriers = async () => {
      try {
        const response = await getAvailableCarriers(bussinessUuid);
        if (response.data.success) {
          setCarriers(response.data.carriers);
        }
      } catch (error) {}
    };
    fetchCarriers();
  }, [bussinessUuid]);

  useEffect(() => {
    const fetchTrackingInfo = async () => {
      if (selectedOrder) {
        try {
          const response = await trackShipment(
            bussinessUuid,
            selectedOrder.orderId,
          );
          if (response.data.success) {
            setTrackingInfo(response.data.tracking);
          } else {
            setTrackingInfo(null);
          }
        } catch (error) {
          setTrackingInfo(null);
        }
      }
    };
    fetchTrackingInfo();
  }, [selectedOrder, bussinessUuid]);

  useEffect(() => {
    const fetchDeliveryDetails = async () => {
      if (selectedOrder && selectedOrder.logistics) {
        try {
          const response = await getDeliveryDetails(
            bussinessUuid,
            selectedOrder.orderId,
          );
          if (response.data.success) {
            setDeliveryDetails(response.data.delivery?.delivery_details);
          }
        } catch (error) {}
      }
    };

    fetchDeliveryDetails();
  }, [selectedOrder, bussinessUuid]);

  useEffect(() => {
    if (storeTheme) {
      setCustomTheme(storeTheme);
    }
  }, [storeTheme]);

  const handleOpenInvoiceDialog = (order) => {
    setSelectedOrder(order);
    setDelaySlotError("");
    setInvoiceDialogOpen(true);
  };

  const handleCloseInvoiceDialog = () => {
    setInvoiceDialogOpen(false);
    setSelectedOrder(null);
    setDelaySlotError("");
    setTrackingInfo(null);
    setDeliveryDetails(null);
  };

  const closeSettingsModal = useCallback(() => {
    setSettingsOpen(false);
    setPreviewBannerImage(null);
    setSelectedBannerFile(null);
    setSelectedPreAddedImage(null);
  }, []);

  const handleOpenTrackingDialog = (order) => {
    navigate(`/${bussinessUuid}/online-store/order-details/${order.orderId}`);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(storeUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
      toast.success("Store link copied to clipboard!");
    } catch {
      setCopied(false);
      toast.error("Failed to copy link");
    }
  };

  async function handleUpdateOrder() {
    try {
      const isDelayedOrder = selectedOrder?.orderStatus === "Delayed";
      const revisedDeliveryDate = selectedOrder?.revisedDeliveryDate?.trim() || "";
      const revisedDeliveryTime = selectedOrder?.revisedDeliveryTime?.trim() || "";

      if (isDelayedOrder && (!revisedDeliveryDate || !revisedDeliveryTime)) {
        const nextError = "Add the updated delivery date and time before marking this order as delayed.";
        setDelaySlotError(nextError);
        toast.error(nextError);
        return;
      }

      setDelaySlotError("");
      const payload = {
        orderStatus: selectedOrder.orderStatus,
        isInvoiceCreated: false,
        ...(isDelayedOrder && {
          revisedDeliveryDate,
          revisedDeliveryTime,
        }),
      };
      const res = await updateOrder(
        bussinessUuid,
        selectedOrder.customerId,
        selectedOrder.orderId,
        payload,
      );
      if (res.status === 200) {
        toast.success("Order updated successfully!");
        setSelectedOrder(res.data);
        handleCloseInvoiceDialog();
        const allOrders = await getAllOrders(bussinessUuid, params);
        if (allOrders?.data?.data) {
          setOrders(allOrders.data.data);
        }
      }
    } catch (error) {
      toast.error("Failed to update order");
    }
  }

  async function handleConfirmReturn(order) {
    setReturnOrderToConfirm(order);
    setReturnConfirmDialogOpen(true);
  }

  async function handleFinalConfirmReturn(order, shouldAssignPickup = false) {
    try {
      const res = await updateOrder(
        bussinessUuid,
        order.customerId,
        order.orderId,
        { orderStatus: "Returned" },
      );
      if (res.status === 200) {
        toast.success("Return confirmed successfully!");
        const allOrders = await getAllOrders(bussinessUuid, params);
        if (allOrders?.data?.data) {
          setOrders(allOrders.data.data);
        }
        
        if (shouldAssignPickup) {
          setAssignmentDialogOrder(res.data || order);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to confirm return");
    } finally {
      setReturnConfirmDialogOpen(false);
      setReturnOrderToConfirm(null);
    }
  }
  // async function handleCreateInvoice() {
  //   if (!selectedOrder) {
  //     toast.error("No order selected!");
  //     return;
  //   }

  //   if (!isOrderFullyDeliveredForInvoice(selectedOrder)) {
  //     toast.error(
  //       "Invoice can be created only after full delivery. Complete all pending quantities first.",
  //     );
  //     return;
  //   }

  //   if (selectedOrder?.isInvoiceCreated) {
  //     toast.info("Invoice is already created for this order");
  //     return;
  //   }

  //   try {
  //     const latestOrderResponse = await getOrderDetails(bussinessUuid, selectedOrder.orderId);
  //     const latestOrder = latestOrderResponse?.data?.data || selectedOrder;
      
  //     const orderToUse = latestOrder;
  //     let mobileNumber = orderToUse.phone || "";
  //     if (mobileNumber) {
  //       mobileNumber = mobileNumber.replace(/^\+?91/, "");
  //       mobileNumber = `+91${mobileNumber}`;
  //     }

  //     const itemsWithVariants = orderToUse.items.map((item) => {
  //       const hasVariants =
  //         item.hasVariants ||
  //         (item.variantId && item.variantId !== null) ||
  //         (item.variantAttributes && item.variantAttributes.length > 0);

  //       let finalVariantId = item.variantId;

  //       if (hasVariants && !finalVariantId) {
  //         if (item.variantCombination) {
  //           finalVariantId = item.variantCombination;
  //         } else if (item.variantKey) {
  //           finalVariantId = `${item.productId}_${item.variantKey}`;
  //         }
  //       }

  //       let variantName = item.variantName;
  //       if (
  //         !variantName &&
  //         item.variantAttributes &&
  //         item.variantAttributes.length > 0
  //       ) {
  //         variantName = item.variantAttributes
  //           .map((attr) => attr.value)
  //           .join(" | ");
  //       }

  //       let variantSku = item.variantSku || item.sku_number;
  //       if (
  //         !variantSku &&
  //         item.variantAttributes &&
  //         item.variantAttributes.length > 0
  //       ) {
  //         const attrString = item.variantAttributes
  //           .map((attr) => attr.value.toLowerCase().replace(/\s+/g, "_"))
  //           .join("_");
  //         variantSku = `${item.productId}_${attrString}`;
  //       }

  //       // Prepare the item data
  //       const itemData = {
  //         productName: item.productName || "",
  //         productId: item.productId || "",
  //         quantity: Number(item.cartQuantity || item.quantity || 0),
  //         salePrice: parseFloat(item.salePrice || item.price || 0),
  //         finalPrice: (
  //           parseFloat(item.salePrice || item.price || 0) *
  //           Number(item.cartQuantity || item.quantity || 0)
  //         ).toFixed(2),
  //         purchasePrice: item.purchasePrice || "0",
  //         discount: item.discount || "0",
  //         discountUnit: item.discountUnit || "%",
  //         igst: item.igst || item.igstRate || "0",
  //         cgst: item.cgst || item.cgstRate || "0",
  //         sgst_utgst: item.sgst_utgst || item.sgstRate || "0",
  //         cess: item.cess || item.cessRate || "0",
  //         sku_number:
  //           item.sku_number && item.sku_number !== "undefined"
  //             ? item.sku_number
  //             : "",

  //         hasVariants: hasVariants,
  //         variantId: finalVariantId,
  //         variantName: variantName,
  //         variantAttributes: item.variantAttributes || [],
  //         variantSku: variantSku,
  //         variantStock: item.variantStock || 0,
  //         variantSalePrice: item.variantSalePrice || item.salePrice,
  //         variantPurchasePrice: item.variantPurchasePrice,
  //         variantMrp: item.variantMrp,
  //         variantBatchNumber: item.variantBatchNumber,

  //         productCategory: item.productCategory || "",
  //         taxable_v: item.taxable_v || "taxable",
  //         weight: item.weight || 0.5,

  //         variantData:
  //           hasVariants && finalVariantId
  //             ? {
  //                 variantId: finalVariantId,
  //                 variantName: variantName,
  //                 variantAttributes: item.variantAttributes || [],
  //                 variantSku: variantSku,
  //                 variantStock: item.variantStock || 0,
  //                 variantSalePrice: item.variantSalePrice || item.salePrice,
  //                 variantPurchasePrice: item.variantPurchasePrice,
  //                 variantMrp: item.variantMrp,
  //               }
  //             : null,

  //         orderItemIdentifier:
  //           item.orderItemIdentifier ||
  //           (hasVariants && finalVariantId
  //             ? `${item.productId}_${finalVariantId}`
  //             : item.productId),
  //       };

  //       Object.keys(itemData).forEach((key) => {
  //         if (itemData[key] === undefined || itemData[key] === null) {
  //           delete itemData[key];
  //         }
  //       });

  //       return itemData;
  //     });

  //     const invalidVariantItems = itemsWithVariants.filter(
  //       (item) => item.hasVariants && !item.variantId,
  //     );

  //     if (invalidVariantItems.length > 0) {
  //       toast.error(
  //         `Please specify variant for: ${invalidVariantItems.map((item) => item.productName).join(", ")}`,
  //       );
  //       return;
  //     }

  //     // const itemsSubtotal = Number(
  //     //   itemsWithVariants
  //     //     .reduce(
  //     //       (sum, item) =>
  //     //         sum + Number(item.salePrice || 0) * Number(item.quantity || 0),
  //     //       0,
  //     //     )
  //     //     .toFixed(2),
  //     // );
  //     const shippingAmount = Number(parseFloat(orderToUse.shippingCost || 0).toFixed(2));
  //     const totalAmount = Number(parseFloat(orderToUse.total || 0).toFixed(2));
      
  //     // Calculate tax based on intra-state (CGST+SGST) vs inter-state (IGST)
  //     let taxAmount = Number(parseFloat(orderToUse.taxAmount || 0).toFixed(2));
      
  //     // Fallback: Calculate from items if taxAmount not stored
  //     if (taxAmount === 0 && itemsWithVariants.length > 0) {
  //       taxAmount = Number(
  //         itemsWithVariants
  //           .reduce((sum, item) => {
  //             const itemTax = 
  //               (item.taxBreakup?.cgst || 0) +
  //               (item.taxBreakup?.sgst || 0) +
  //               (item.taxBreakup?.igst || 0) +
  //               (item.taxBreakup?.cess || 0);
  //             return sum + itemTax;
  //           }, 0)
  //           .toFixed(2)
  //       );
  //     }

  //     const payload = {
  //       items: JSON.stringify(itemsWithVariants), // Use itemsWithVariants instead of duplicate mapping
  //       mobile: mobileNumber || "",
  //       customerName: orderToUse.customerName || "",
  //       transactionAmount: Number(totalAmount),
  //       remainingTransactionAmount: Number(0),
  //       transactionStatus: "paid",
  //       additionalFee: [
  //         ...(shippingAmount > 0
  //           ? [{ label: "Shipping", amount: shippingAmount, type: "fixed" }]
  //           : []),
  //         ...(taxAmount > 0
  //           ? [{ label: "Tax", amount: taxAmount, type: "fixed" }]
  //           : []),
  //       ],
  //       deliveryFee: shippingAmount,
  //       dateTime: new Date().toISOString(),
  //       paymentMode: orderToUse.paymentMethod || "cash",
  //       deliveryDate: orderToUse.deliveryDate || new Date(),
  //       deliveryTime: orderToUse.deliveryTime || "",
  //       assignedEmployee: orderToUse.assignedEmployee || "",
  //       country: orderToUse.country || "",
  //       state: orderToUse.state || "",
  //       address: orderToUse.address || "",
  //       saleDate: new Date().toISOString(),
  //       committedDateToPay: orderToUse.committedDateToPay || "",
  //       pickupDate: orderToUse.pickupDate || "",
  //       isServices: false,
  //       saleType: "confirmSale",
  //       saleSource: "online", // Moved from duplicate location
  //       notes: `Online Store Order #${orderToUse.orderId} | Payment: ${orderToUse.paymentMethod}`, // Moved from duplicate location
  //       orderId: orderToUse.orderId, // Moved from duplicate location

  //       orderReference: {
  //         orderId: orderToUse.orderId,
  //         orderUuid: orderToUse.orderUuid,
  //         orderDate: orderToUse.orderDate,
  //       },
  //     };

  //     const saleResponse = await createSale(bussinessUuid, payload); // Renamed variable to avoid conflict

  //     if (saleResponse?.status === 201) {
  //       toast.success("Invoice created successfully!");

  //       const orderUpdatePayload = {
  //         orderStatus: orderToUse.orderStatus,
  //         isInvoiceCreated: true,
  //         paymentStatus: orderToUse.paymentStatus || "pending",
  //       };

  //       await updateOrder(
  //         bussinessUuid,
  //         orderToUse.customerId,
  //         orderToUse.orderId,
  //         orderUpdatePayload,
  //       );

  //       setSelectedOrder((prev) => ({
  //         ...prev,
  //         orderStatus: "Confirmed",
  //         isInvoiceCreated: true,
  //       }));

  //       handleCloseInvoiceDialog();

  //       const allOrders = await getAllOrders(bussinessUuid, params);
  //       if (allOrders?.data?.data) {
  //         setOrders(allOrders.data.data);
  //       }

  //       toast.success("Invoice created and order updated successfully!");
  //     } else if (saleResponse?.data?.message) {
  //       if (
  //         saleResponse.data.message.includes("has variants") &&
  //         saleResponse.data.message.includes("Please specify a variantId")
  //       ) {
  //         toast.error(
  //           "Variant selection required: " + saleResponse.data.message,
  //         );
  //       } else {
  //         toast.error(saleResponse.data.message || "Failed to create invoice");
  //       }
  //     } else {
  //       toast.error(saleResponse?.data?.message || "Failed to create invoice");
  //     }
  //   } catch (error) {
  //     console.error("Error creating invoice:", error);

  //     // Handle specific variant errors
  //     if (error.message) {
  //       if (
  //         error.message.includes("has variants") &&
  //         error.message.includes("Please specify a variantId")
  //       ) {
  //         toast.error(
  //           "Some products have variants. Please ensure all variant products have variant IDs specified.",
  //         );
  //       } else if (error.response?.data?.message) {
  //         toast.error(
  //           "Failed to create invoice: " + error.response.data.message,
  //         );
  //       } else {
  //         toast.error(
  //           "Something went wrong while creating invoice: " +
  //             (error.message || "Unknown error"),
  //         );
  //       }
  //     } else {
  //       toast.error("Something went wrong while creating invoice");
  //     }
  //   }
  // }
  // ============ END UPDATED VARIANT LOGIC ============

  const handleChangeForBanner = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setSelectedBannerFile(file);

    const reader = new FileReader();
    reader.onload = () => {
      setBannerImagePreview(reader.result);
      setIsCropModalOpen(true);
    };
    reader.readAsDataURL(file);
  };

  const handlePreAddedImageSelect = (image) => {
    setSelectedPreAddedImage(image);
    setBannerImagePreview(image.src);
    setIsCropModalOpen(true);
  };

  const handleCropComplete = async (croppedFile) => {
    try {
      setUploadingBanner(true);

      const formData = new FormData();
      formData.append("bannerImage", croppedFile);

      const result = await updateBussinessData(bussinessUuid, formData);

      if (result.status === 200) {
        toast.success("Banner image uploaded successfully!");

        let imageUrl = result.data?.bannerImage;

        if (!imageUrl) {
          imageUrl = result.data?.data?.bannerImage;
        }

        if (imageUrl) {
          let fullImageUrl = imageUrl;
          if (imageUrl && !imageUrl.startsWith("http")) {
            if (imageUrl.startsWith("/")) {
              fullImageUrl = `${window.location.origin}${imageUrl}`;
            } else {
              fullImageUrl = `https://dukanbuddy-normal.s3.us-east-1.amazonaws.com/${imageUrl}`;
            }
          }

          const bannerData = {
            type: "image",
            imageUrl: fullImageUrl,
          };

          setStoreBanner(bannerData);
          setPreviewBannerImage(fullImageUrl);

          await storeSettingsService.updateAllSettings(bussinessUuid, {
            bannerImage: bannerData,
          });

          toast.success("Banner updated in settings!");
        } else {
          toast.info("Uploaded successfully, but couldn't extract image URL");
        }
      }

      setSelectedBannerFile(null);
      setSelectedPreAddedImage(null);
      setBannerImagePreview("");
    } catch (error) {
      toast.error("Failed to upload banner image");
    } finally {
      setUploadingBanner(false);
      setIsCropModalOpen(false);
    }
  };

  const handleColorBannerSave = async () => {
    try {
      setUploadingBanner(true);

      const bannerData = {
        type: "color",
        color: bannerColor,
      };

      const form = new FormData();
      form.append("bannerData", JSON.stringify(bannerData));

      const result = await updateBussinessData(bussinessUuid, form);

      if (result.status === 200) {
        toast.success("Color banner saved successfully!");
        setStoreBanner(bannerData);
      }
    } catch (error) {
      toast.error("Failed to save color banner");
    } finally {
      setUploadingBanner(false);
    }
  };

 const handleSave = async () => {
  try {
    const payload = {};
    const normalizedDraftTheme = normalizeThemeForSave(customTheme);
    const normalizedSavedTheme = normalizeThemeForSave(storeTheme);
    const hasUnsavedThemeChanges = !areThemesEqual(
      normalizedDraftTheme,
      normalizedSavedTheme,
    );

    if (activeSettingsTab === "general") {
      payload.storeDescription = description;
      payload.checkoutSettings = {
        cashOnDeliveryEnabled,
      };
      // NEW: Add Call & WhatsApp settings to payload
      payload.callAndWhatsappSettings = {
        showCallButton,
        showWhatsappButton,
        phoneNumber: callPhoneNumber,
        whatsappNumber: whatsappNumber,
        whatsappMessage: whatsappMessage,
      };
    }

    if (activeSettingsTab === "banner") {
      if (bannerType === "image" && selectedBannerFile) {
        toast.info("Please crop and save the image first");
        return;
      } else if (bannerType === "color") {
        await handleColorBannerSave();
        payload.bannerImage = {
          type: "color",
          color: bannerColor,
        };
      } else if (bannerType === "pre-added" && selectedPreAddedImage) {
        toast.info("Please crop and save the image first");
        return;
      }
    }

    if (hasUnsavedThemeChanges && normalizedDraftTheme) {
      payload.theme = normalizedDraftTheme;
    }

    if (activeSettingsTab === "layout") {
      const updatedLayout = {
        type: activeLayout,
        showLanding: layoutSettings?.showLanding !== false,
        layoutSettings: layoutSettings?.layoutSettings || {
          showNavigation: true,
          autoRedirect: false,
          redirectDelay: 0,
          featuredSections: [
            {
              title: "Premium Products",
              description: "Carefully curated selection",
              icon: "📦",
              enabled: true,
            },
            {
              title: "Fast Delivery",
              description: "Quick and reliable shipping",
              icon: "🚚",
              enabled: true,
            },
            {
              title: "Best Quality",
              description: "Top-notch customer satisfaction",
              icon: "⭐",
              enabled: true,
            },
          ],
        },
      };

      const layoutResponse = await storeSettingsService.updateLayout(
        bussinessUuid,
        updatedLayout,
      );
      if (layoutResponse.success) {
        setLayoutSettings(updatedLayout);
        payload.layout = updatedLayout;
      }
    }

    if (Object.keys(payload).length === 0) {
      toast.info("No new settings to save");
      closeSettingsModal();
      return;
    }

    const response = await storeSettingsService.updateAllSettings(
      bussinessUuid,
      payload,
    );
    
    if (response.success) {
      if (payload.theme) {
        setStoreTheme(payload.theme);
        setCustomTheme(payload.theme);
      }
      
      // NEW: Show success message with what was saved
      if (payload.callAndWhatsappSettings) {
        toast.success("Call & WhatsApp settings saved successfully!");
      }
      
      toast.success(response.message || "Settings saved successfully!");
      closeSettingsModal();
    } else {
      toast.error(response.error || "Failed to save settings");
    }
  } catch (error) {
    console.error('Error saving settings:', error);
    toast.error("Error saving settings");
  }
};

  const handleSaveTheme = useCallback(
    async (theme) => {
      try {
        const normalizedTheme = {
          ...normalizeThemeForSave(theme),
          themeSelectionSource: "custom",
        };
        const response = await storeSettingsService.updateTheme(
          bussinessUuid,
          normalizedTheme,
        );
        if (response.success) {
          setStoreTheme(normalizedTheme);
          setCustomTheme(normalizedTheme);
          toast.success(response.message || "Theme saved successfully!");
        } else {
          toast.error(response.error || "Failed to save theme");
        }
      } catch (error) {
        toast.error("Error saving theme");
      }
    },
    [bussinessUuid, normalizeThemeForSave],
  );

  const handleCustomThemeChange = (key, value) => {
    const updatedTheme = {
      ...(customTheme || {
        fontFamily: "Inter",
        primaryColor: "#4f46e5",
        secondaryColor: "#10b981",
        backgroundColor: "#ffffff",
        buttonColor: "#4f46e5",
        textColor: "#1f2937",
        headingColor: "#111827",
        borderRadius: "12px",
        buttonStyle: "rounded",
        themeName: "Custom Theme",
        cardStyle: "shadow",
      }),
      [key]: value,
    };
    setCustomTheme(updatedTheme);
  };



  const handleToggleLandingPage = async () => {
    try {
      const newShowLanding = !layoutSettings?.showLanding;
      const response = await storeSettingsService.toggleLandingPage(
        bussinessUuid,
        newShowLanding,
      );

      if (response.success) {
        setLayoutSettings((prev) => ({
          ...prev,
          showLanding: newShowLanding,
        }));
        toast.success(
          `Landing page ${newShowLanding ? "enabled" : "disabled"}`,
        );
      }
    } catch (error) {
      toast.error("Failed to update landing page setting");
    }
  };

  const StatusBadge = ({ status }) => {
    const statusColors = {
      Shipped: "bg-blue-100 text-blue-800 border border-blue-200",
      Ordered: "bg-amber-100 text-amber-800 border border-amber-200",
      Approved: "bg-sky-100 text-sky-800 border border-sky-200",
      Delivered: "bg-emerald-100 text-emerald-800 border border-emerald-200",
      "Partially Delivered":
        "bg-teal-100 text-teal-800 border border-teal-200",
      Delayed: "bg-orange-100 text-orange-800 border border-orange-200",
      Processing: "bg-violet-100 text-violet-800 border border-violet-200",
      Confirmed: "bg-cyan-100 text-cyan-800 border border-cyan-200",
      Cancelled: "bg-rose-100 text-rose-800 border border-rose-200",
      "Pending return":
        "bg-orange-100 text-orange-800 border border-orange-200",
      Returned: "bg-purple-100 text-purple-800 border border-purple-200",
      paid: "bg-emerald-100 text-emerald-800 border border-emerald-200",
      partial_paid: "bg-orange-100 text-orange-800 border border-orange-200",
      pending: "bg-amber-100 text-amber-800 border border-amber-200",
      failed: "bg-rose-100 text-rose-800 border border-rose-200",
      refunded: "bg-indigo-100 text-indigo-800 border border-indigo-200",
      Paid: "bg-emerald-100 text-emerald-800 border border-emerald-200",
      "Partial Paid": "bg-orange-100 text-orange-800 border border-orange-200",
      Pending: "bg-amber-100 text-amber-800 border border-amber-200",
      Failed: "bg-rose-100 text-rose-800 border border-rose-200",
      Refunded: "bg-indigo-100 text-indigo-800 border border-indigo-200",
    };

    return (
      <span
        className={`px-3 py-1 rounded-full text-xs font-semibold ${
          statusColors[status] ||
          "bg-gray-100 text-gray-800 border border-gray-200"
        } transition-colors`}
      >
        {status}
      </span>
    );
  };

  const handleViewStorePreview = () => {
    window.open(
      getLandingPagePath({
        businessName: displayBusinessName,
        bussinessUuid,
      }),
      "_blank",
    );
  };

  const handleViewLandingPreview = () => {
    window.open(
      getLandingPagePath({
        businessName: displayBusinessName,
        bussinessUuid,
      }),
      "_blank",
    );
  };

  const handleLayoutSelect = (layoutId) => {
    setActiveLayout(layoutId);
  };

  const formatPreferredDeliverySlot = (order) => {
    const preferredDate = order?.preferredDeliveryDate?.trim();
    const preferredTime = order?.preferredDeliveryTime?.trim();

    if (preferredDate && preferredTime) {
      return `${preferredDate} at ${preferredTime}`;
    }

    return preferredDate || preferredTime || "—";
  };

  const resolvePaymentStatus = (order) => {
    const rawPaymentStatus = String(order?.paymentStatus || "").toLowerCase();
    const isDelivered = String(order?.orderStatus || "").toLowerCase() === "delivered";
    const isCod = String(order?.paymentMethod || order?.paymentMode || "").toLowerCase() === "cod";

    if (isDelivered && isCod) {
      const collectedAmount = Number(parseFloat(order?.paymentCollection?.collectionAmount || 0).toFixed(2));
      const toBeCollectedAmount = Number(
        parseFloat(order?.paymentCollection?.toBeCollectedAmount || order?.total || 0).toFixed(2),
      );

      if (collectedAmount > 0 && collectedAmount === toBeCollectedAmount) {
        return "paid";
      }

      return rawPaymentStatus || "pending";
    }

    return rawPaymentStatus || "unknown";
  };

  const formatRevisedDeliverySlot = (order) => {
    const revisedDate = order?.revisedDeliveryDate?.trim();
    const revisedTime = order?.revisedDeliveryTime?.trim();

    if (revisedDate && revisedTime) {
      return `${revisedDate} at ${revisedTime}`;
    }

    return revisedDate || revisedTime || "—";
  };

  const hasPreferredDeliverySlot = Boolean(
    selectedOrder?.preferredDeliveryDate?.trim() &&
      selectedOrder?.preferredDeliveryTime?.trim(),
  );

  const isDelayedOrderSelected = selectedOrder?.orderStatus === "Delayed";

  const bannerTypeOptions = [
    { value: "image", label: "Upload Custom Image", icon: <MdImage /> },
    {
      value: "pre-added",
      label: "Choose Pre-added Image",
      icon: <MdWallpaper />,
    },
    { value: "color", label: "Solid Color", icon: <MdFormatColorFill /> },
  ];

  return (
    <div className='mx-1 my-1'>
      {" "}
      {/* Added margin of 1 on all sides */}
      <button
        onClick={() => setQrModalOpen(true)}
        className='fixed bottom-6 right-6 z-40 p-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300 animate-bounce-slow'
        title='Generate Store QR Code'
      >
        <MdQrCode size={28} />
      </button>
      <div className='mb-8 space-y-6'>
        {/* Header with Title and Primary Actions */}
        <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4'>
          {/* Title Section */}
          <div className='flex items-start gap-4'>
            <div className='relative'>
              <div className='p-3 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl shadow-lg'>
                <MdStore className='text-white' size={28} />
              </div>
              <div className='absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white dark:border-gray-900 animate-pulse'></div>
            </div>

            <div>
              <div className='flex items-center gap-3 flex-wrap'>
                <h1 className='text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-300 bg-clip-text text-transparent'>
                  {t("ONLINE_STORE.ORDERS_DASHBOARD")}
                </h1>

                {/* Store Status Badge */}
                <div
                  className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1.5 ${
                    layoutSettings?.showLanding !== false
                      ? "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-800"
                      : "bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700"
                  }`}
                >
                  <span
                    className={`w-2 h-2 rounded-full ${
                      layoutSettings?.showLanding !== false
                        ? "bg-green-500 animate-pulse"
                        : "bg-gray-400"
                    }`}
                  ></span>
                  {layoutSettings?.showLanding !== false
                    ? "Store Live"
                    : "Store Offline"}
                </div>
              </div>

              <p className='mt-1.5 text-gray-600 dark:text-gray-400 flex items-center gap-2'>
                <span className='w-1 h-1 bg-gray-400 rounded-full'></span>
                {t("ONLINE_STORE.MANAGE_YOUR_STORE")}
                <span className='w-1 h-1 bg-gray-400 rounded-full'></span>
                <span className='text-sm font-medium text-indigo-600 dark:text-indigo-400'>
                  {orders.length} {t("ONLINE_STORE.TOTAL_ORDERS")}
                </span>
              </p>
            </div>
          </div>

          {/* Quick Actions Dropdown - Replaces multiple buttons */}
          <div className='flex items-center gap-3'>
            {/* Primary Action Button */}
            <button
              onClick={handleViewStorePreview}
              className='inline-flex items-center justify-center gap-2.5 px-5 py-2.5 rounded-xl font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg transform hover:scale-105 text-sm'
            >
              <MdStore size={18} />
              <span>{t("ONLINE_STORE.VIEW_STORE")}</span>
            </button>

            {/* Settings Dropdown */}
            <Menu as='div' className='relative'>
              <Menu.Button className='inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all shadow-sm hover:shadow-md'>
                <MdSettings size={18} />
                <span>{t("SETTINGS.GENERAL_SETTINGS")}</span>
                <svg
                  className='w-4 h-4'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M19 9l-7 7-7-7'
                  />
                </svg>
              </Menu.Button>

              <Menu.Items className='absolute right-0 mt-2 w-72 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700 py-2 z-50'>
                <div className='px-4 py-2 border-b border-gray-200 dark:border-gray-700'></div>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => setSettingsOpen(true)}
                      className={`${
                        active ? "bg-indigo-50 dark:bg-indigo-900/20" : ""
                      } flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <div className='p-1.5 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400'>
                        <MdSettings size={16} />
                      </div>
                      <div className='flex-1 text-left'>
                        <p className='font-medium'>
                          {" "}
                          {t("ONLINE_STORE.STORE_SETTINGS")}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleToggleLandingPage}
                      className={`${
                        active ? "bg-indigo-50 dark:bg-indigo-900/20" : ""
                      } flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <div
                        className={`p-1.5 rounded-lg ${
                          layoutSettings?.showLanding !== false
                            ? "bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400"
                            : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                        }`}
                      >
                        {layoutSettings?.showLanding !== false ? (
                          <MdVisibility size={16} />
                        ) : (
                          <MdVisibilityOff size={16} />
                        )}
                      </div>
                      <div className='flex-1 text-left'>
                        <p className='font-medium'>
                          {layoutSettings?.showLanding !== false
                            ? t("SETTINGS.DISABLE_LANDING")
                            : t("SETTINGS.ENABLE_LANDING")}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>

                <div className='border-t border-gray-200 dark:border-gray-700 my-2'></div>

                <div className='px-4 py-2'>
                  <p className='text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2'>
                    {t("BUYSIDER.LOGISTICS")}
                  </p>
                </div>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() =>
                        navigate(
                          `/${bussinessUuid}/dashboard/logistics/settings`,
                        )
                      }
                      className={`${
                        active ? "bg-indigo-50 dark:bg-indigo-900/20" : ""
                      } flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <div className='p-1.5 rounded-lg bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'>
                        <MdLocalShipping size={16} />
                      </div>
                      <div className='flex-1 text-left'>
                        <p className='font-medium'>
                          {t("LOGISTICS.LOGISTICS_SETTINGS")}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>

                <div className='border-t border-gray-200 dark:border-gray-700 my-2'></div>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() =>
                        navigate(`/${bussinessUuid}/dashboard/guest-tracking`)
                      }
                      className={`${
                        active ? "bg-indigo-50 dark:bg-indigo-900/20" : ""
                      } flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <div className='p-1.5 rounded-lg bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'>
                        <MdQrCode size={16} />
                      </div>
                      <div className='flex-1 text-left'>
                        <p className='font-medium'>
                          {t("TRACKING.GUEST_TRACKING")}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => setQrModalOpen(true)}
                      className={`${
                        active ? "bg-indigo-50 dark:bg-indigo-900/20" : ""
                      } flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <div className='p-1.5 rounded-lg bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400'>
                        <MdQrCode size={16} />
                      </div>
                      <div className='flex-1 text-left'>
                        <p className='font-medium'>
                          {t("QRCODE.STORE_QR_CODE")}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>

            {/* Refresh Button */}
            <button
              onClick={() => {
                const fetchOrders = async () => {
                  try {
                    const allOrders = await getAllOrders(bussinessUuid, params);
                    if (allOrders?.data?.data) {
                      setOrders(allOrders.data.data);
                    }
                    toast.success("Orders refreshed");
                  } catch (error) {
                    toast.error("Failed to refresh");
                  }
                };
                fetchOrders();
              }}
              className='p-2.5 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all'
              title='Refresh Orders'
            >
              <svg
                className='w-5 h-5'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Stats Cards - Redesigned with better visuals */}
        <div className='grid grid-cols-2 lg:grid-cols-4 gap-4'>
          {/* Total Orders Card */}
          <div className='group bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 hover:-translate-y-1'>
            <div className='p-5'>
              <div className='flex items-center justify-between mb-3'>
                <div className='p-2.5 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-lg group-hover:scale-110 transition-transform'>
                  <MdShoppingCart size={20} />
                </div>
                <span className='text-xs font-medium text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 px-2 py-1 rounded-full'>
                  +12%
                </span>
              </div>
              <p className='text-sm font-medium text-gray-500 dark:text-gray-400 mb-1'>
                {t("ONLINE_STORE.TOTAL_ORDERS")}
              </p>
              <p className='text-2xl font-bold text-gray-900 dark:text-white'>
                {orders.length}
              </p>
              <p className='text-xs text-gray-400 dark:text-gray-500 mt-2 flex items-center gap-1'>
                <span className='w-1.5 h-1.5 bg-blue-500 rounded-full'></span>
                {t("ONLINE_STORE.ALL_TIME_ORDERS")}
              </p>
            </div>
          </div>

        <div className='group bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 hover:-translate-y-1'>
  <div className='p-5'>
    <div className='flex items-center justify-between mb-3'>
      <div className='p-2.5 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 text-white shadow-lg group-hover:scale-110 transition-transform'>
        <MdAttachMoney size={20} />
      </div>
      <span className='text-xs font-medium text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/30 px-2 py-1 rounded-full'>
        ₹{totalRevenue.toFixed(2)}
      </span>
    </div>
    <p className='text-sm font-medium text-gray-500 dark:text-gray-400 mb-1'>
      {t("ONLINE_STORE.REVENUE")}
    </p>
    <p className='text-2xl font-bold text-gray-900 dark:text-white'>
      ₹{totalRevenue.toFixed(2)}
    </p>
    <p className='text-xs text-gray-400 dark:text-gray-500 mt-2 flex items-center gap-1'>
      <span className='w-1.5 h-1.5 bg-emerald-500 rounded-full'></span>
      {t("ONLINE_STORE.TOTAL_EARNINGS")}
    </p>
  </div>
</div>

          {/* Shipped Orders Card */}
          <div className='group bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 hover:-translate-y-1'>
            <div className='p-5'>
              <div className='flex items-center justify-between mb-3'>
                <div className='p-2.5 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 text-white shadow-lg group-hover:scale-110 transition-transform'>
                  <MdLocalShipping size={20} />
                </div>
                <span className='text-xs font-medium text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-full'>
                  {(
                    (orders.filter((o) => o.logistics).length /
                      (orders.length || 1)) *
                    100
                  ).toFixed(0)}
                  %
                </span>
              </div>
              <p className='text-sm font-medium text-gray-500 dark:text-gray-400 mb-1'>
                {t("ONLINE_STORE.SHIPPED_ORDERS")}
              </p>
              <p className='text-2xl font-bold text-gray-900 dark:text-white'>
                {orders.filter((order) => order.logistics).length}
              </p>
              <p className='text-xs text-gray-400 dark:text-gray-500 mt-2 flex items-center gap-1'>
                <span className='w-1.5 h-1.5 bg-amber-500 rounded-full'></span>
                {t("ONLINE_STORE.WITH_TRACKING")}
              </p>
            </div>
          </div>

          {/* Current Layout Card */}
          <div className='group bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 hover:-translate-y-1'>
            <div className='p-5'>
              <div className='flex items-center justify-between mb-3'>
                <div className='p-2.5 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 text-white shadow-lg group-hover:scale-110 transition-transform'>
                  <MdHome size={20} />
                </div>
                <span
                  className={`text-xs font-medium px-2 py-1 rounded-full ${
                    layoutSettings?.showLanding !== false
                      ? "bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400"
                      : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                  }`}
                >
                  {layoutSettings?.showLanding !== false ? "Live" : "Offline"}
                </span>
              </div>
              <p className='text-sm font-medium text-gray-500 dark:text-gray-400 mb-1'>
                {t("ONLINE_STORE.CURRENT_LAYOUT")}
              </p>
              <p className='text-2xl font-bold text-gray-900 dark:text-white capitalize truncate'>
                {layoutSettings?.type?.split("-").join(" ") || "Fullscreen"}
              </p>
              <p className='text-xs text-gray-400 dark:text-gray-500 mt-2 flex items-center gap-1'>
                <span
                  className={`w-1.5 h-1.5 rounded-full ${
                    layoutSettings?.showLanding !== false
                      ? "bg-green-500"
                      : "bg-gray-400"
                  }`}
                ></span>
                {layoutSettings?.showLanding !== false
                  ? "Landing enabled"
                  : "Landing disabled"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-white dark:bg-gray-800 shadow-xl rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 hover:shadow-2xl transition-all duration-300'>
        {/* Header Section */}
        <div className='px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-indigo-50/80 via-white to-white dark:from-gray-800 dark:to-gray-800'>
          <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
            <div className='flex items-center gap-3'>
              <div className='p-2 bg-indigo-100 dark:bg-indigo-900/50 rounded-xl'>
                <svg
                  className='w-5 h-5 text-indigo-600 dark:text-indigo-400'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z'
                  />
                </svg>
              </div>
              <div>
                <h2 className='text-lg sm:text-xl font-bold text-gray-900 dark:text-white'>
                  {t("ONLINE_STORE.RECENT_ORDERS")}
                </h2>
                <p className='text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5'>
                  {t("ONLINE_STORE.ALL_YOUR_STORE_ORDERS")}
                </p>
              </div>
            </div>

            {/* Search Input */}
            <div className='relative w-full sm:w-64'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <svg
                  className='h-4 w-4 text-gray-400'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                  />
                </svg>
              </div>
              <input
                type='text'
                placeholder='Search orders...'
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                className='w-full pl-10 pr-4 py-2.5 text-sm border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all'
              />
            </div>
          </div>
        </div>

        {/* Responsive Table Container */}
        <div className='relative'>
       {/* Mobile View - Card Layout */}
<div className='block lg:hidden divide-y divide-gray-200 dark:divide-gray-700 max-h-[500px] overflow-y-auto'>
  {!Array.isArray(orders) || orders.length === 0 ? (
    <div className='py-16 px-4 text-center'>
      <div className='flex flex-col items-center justify-center'>
        <div className='p-4 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 rounded-2xl mb-4'>
          <MdReceipt size={48} className='text-gray-400 dark:text-gray-500' />
        </div>
        <p className='text-lg font-semibold text-gray-700 dark:text-gray-300 mb-1'>
          {t("ORDER_HISTORY.NO_ORDER_YET")}
        </p>
        <p className='text-sm text-gray-500 dark:text-gray-400'>
          {t("ONLINE_STORE.YOUR_STORE_ORDERS_WILL_APPEAR_HERE")}
        </p>
      </div>
    </div>
  ) : (
    orders.map((order, idx) => {
      const isPending = isOrderPending(order);
      
      return (
        <div
          key={order?._id || idx}
          className={`p-4 transition-all duration-200 ${
            isPending 
              ? "bg-yellow-50/50 dark:bg-yellow-900/20 opacity-75" 
              : "hover:bg-indigo-50/50 dark:hover:bg-gray-700/50"
          }`}
        >
          {/* Order Header */}
          <div className='flex items-start justify-between mb-3'>
            <div className='flex items-center gap-2'>
              <span className='inline-flex items-center px-2.5 py-1 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 text-xs font-mono font-medium border border-indigo-200 dark:border-indigo-800 self-start'>
                #{order?.orderId || "N/A"}
              </span>
              <div>
                <div className='text-xs text-gray-500 dark:text-gray-400'>
                  {order?.orderDate || "—"}
                </div>
                <div className='text-xs font-medium text-gray-600 dark:text-gray-300 mt-0.5'>
                  Preferred Delivery Slot: {formatPreferredDeliverySlot(order)}
                </div>
              </div>
            </div>
            <div className='flex items-center gap-1'>
              <button
                onClick={() => handleOpenInvoiceDialog(order)}
                disabled={isPending}
                className={`p-2 rounded-lg transition-all duration-200 ${
                  isPending
                    ? "text-gray-400 cursor-not-allowed opacity-50"
                    : "text-indigo-600 hover:text-indigo-700 hover:bg-indigo-100 dark:hover:bg-indigo-900/30"
                }`}
                title={isPending ? "Order pending verification/review" : "Edit Order"}
              >
                <MdEdit size={16} />
              </button>
              {showTrackOrderButton && (
                <button
                  onClick={() => handleOpenTrackingDialog(order)}
                  disabled={isPending}
                  className={`p-2 rounded-lg transition-all duration-200 ${
                    isPending
                      ? "text-gray-400 cursor-not-allowed opacity-50"
                      : "text-green-600 hover:text-green-700 hover:bg-green-100 dark:hover:bg-green-900/30"
                  }`}
                  title={isPending ? "Order pending verification/review" : "Track Order"}
                >
                  <MdStore size={16} />
                </button>
              )}
              {employeeDeliveryEnabled && renderDeliveryAssignmentControls(order, true)}
              {order?.orderStatus === "Pending return" && !isPending && (
                <button
                  onClick={() => handleConfirmReturn(order)}
                  className='p-2 text-orange-600 hover:text-orange-700 hover:bg-orange-100 dark:hover:bg-orange-900/30 rounded-lg transition-all duration-200'
                  title={`Confirm Return${order?.returnReason ? ` — Reason: ${order.returnReason}` : ""}`}
                >
                  <MdCheck size={16} />
                </button>
              )}
            </div>
          </div>

          {/* Customer Info */}
          <div className='flex items-center mb-3'>
            <div className='flex-shrink-0 h-10 w-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white text-sm font-semibold shadow-md'>
              {order?.customerName?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div className='ml-3'>
              <div className='text-sm font-medium text-gray-900 dark:text-white'>
                {order?.customerName || "Unknown"}
              </div>
              {(order?.phone || order?.customerMobile || order?.customerPhone) && (
                <div className='text-xs text-gray-500 dark:text-gray-400 mt-0.5'>
                  {order?.phone || order?.customerMobile || order?.customerPhone}
                </div>
              )}
              {isPending && (
                <span className='text-xs text-yellow-600 dark:text-yellow-400 flex items-center gap-1 mt-0.5'>
                  <MdWarning size={10} />
                  Pending Action
                </span>
              )}
            </div>
          </div>

          {/* Order Details Grid */}
          <div className='grid grid-cols-2 gap-3 text-sm'>
            <div>
              <div className='text-xs text-gray-500 dark:text-gray-400 mb-1'>
                {t("SIDER.ORDER_STATUS")}
              </div>
              {isPending ? (
                <span className='inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300'>
                  <MdWarning size={12} />
                  {order?.orderStatus || "Pending"}
                </span>
              ) : (
                <StatusBadge status={order?.orderStatus || "Unknown"} />
              )}
              {order?.partialDelivery?.enabled && (
                <p className='mt-1 text-[11px] text-gray-500 dark:text-gray-400'>
                  {getPartialDeliverySummary(order).delivered}/
                  {getPartialDeliverySummary(order).ordered} delivered
                </p>
              )}
            </div>
            <div>
              <div className='text-xs text-gray-500 dark:text-gray-400 mb-1'>
                {t("BUYSIDER.LOGISTICS")}
              </div>
              <LogisticsStatusBadge order={order} />
            </div>
            <div>
              <div className='text-xs text-gray-500 dark:text-gray-400 mb-1'>
                {t("PAYROLL.PAYMENT_STATUS")}
              </div>
              <StatusBadge status={resolvePaymentStatus(order)} />
            </div>
            <div>
              <div className='text-xs text-gray-500 dark:text-gray-400 mb-1'>
                {t("INVOICE.TOTAL")}
              </div>
              <div className='text-sm font-bold text-gray-900 dark:text-white'>
                ${typeof order?.total === "number" ? order.total.toFixed(2) : "0.00"}
              </div>
            </div>
          </div>
          
        
        </div>
      );
    })
  )}
</div>

          {/* Desktop View - Table */}
          <div className='hidden lg:block w-full max-h-[500px] overflow-x-auto overflow-y-auto'>
            <table className='w-full min-w-[1000px] divide-y divide-gray-200 dark:divide-gray-700'>
              {/* Table Header */}
              <thead className='bg-gray-50 dark:bg-gray-700/90 sticky top-0 z-10 backdrop-blur-sm'>
                <tr>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("ONLINE_STORE.ORDER")} #
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("ONLINE_STORE.CUSTOMER")}
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("HOLIDAY.DATE")}
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("SIDER.ORDER_STATUS")}
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("BUYSIDER.LOGISTICS")}
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("PAYROLL.PAYMENT_STATUS")}
                  </th>
                  <th className='py-4 px-3 text-right text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("INVOICE.TOTAL")}
                  </th>
                  <th className='py-4 px-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider'>
                    {t("WAGEPAYROLL.ACTION")}
                  </th>
                </tr>
              </thead>

            {/* Table Body */}
<tbody className='bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700'>
  {!Array.isArray(orders) || orders.length === 0 ? (
    <tr>
      <td colSpan={8} className='py-16 px-4 text-center'>
        <div className='flex flex-col items-center justify-center'>
          <div className='p-4 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 rounded-2xl mb-4'>
            <MdReceipt size={48} className='text-gray-400 dark:text-gray-500' />
          </div>
          <p className='text-lg font-semibold text-gray-700 dark:text-gray-300 mb-1'>
            {t("ORDER_HISTORY.NO_ORDER_YET")}
          </p>
          <p className='text-sm text-gray-500 dark:text-gray-400'>
            Your store orders will appear here
          </p>
        </div>
      </td>
    </tr>
  ) : (
    orders.map((order, idx) => {
      const isPending = isOrderPending(order);
      
      return (
        <tr
          key={order?._id || idx}
          className={`group hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition-all duration-200 ${
            isPending ? "opacity-60 bg-yellow-50/30 dark:bg-yellow-900/20" : ""
          }`}
        >
          {/* Order ID */}
          <td className='py-4 px-3 whitespace-nowrap'>
            <span className='inline-flex items-center px-2.5 py-1 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 text-xs font-mono font-medium border border-indigo-200 dark:border-indigo-800'>
              #{order?.orderId || "N/A"}
            </span>
          </td>

          {/* Customer */}
          <td className='py-4 px-3 whitespace-nowrap'>
            <div className='flex items-center'>
              <div className='flex-shrink-0 h-8 w-8 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white text-xs font-semibold shadow-md'>
                {order?.customerName?.charAt(0)?.toUpperCase() || "U"}
              </div>
              <div className='ml-3'>
                <div className='text-sm font-medium text-gray-900 dark:text-white'>
                  {order?.customerName || "Unknown"}
                </div>
                {(order?.phone || order?.customerMobile || order?.customerPhone) && (
                  <div className='text-xs text-gray-500 dark:text-gray-400 mt-0.5 font-mono'>
                    {order?.phone || order?.customerMobile || order?.customerPhone}
                  </div>
                )}
                {isPending && (
                  <span className='text-xs text-yellow-600 dark:text-yellow-400 flex items-center gap-1 mt-0.5'>
                    <MdWarning size={10} />
                    Pending Action
                  </span>
                )}
              </div>
            </div>
          </td>

          {/* Date */}
          <td className='py-4 px-3'>
            <div className='text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap'>
              {order?.orderDate || "—"}
            </div>
            <div className='text-xs font-medium text-gray-500 dark:text-gray-400 mt-1'>
              Preferred Delivery Slot: {formatPreferredDeliverySlot(order)}
            </div>
          </td>

          {/* Order Status */}
          <td className='py-4 px-3 whitespace-nowrap'>
            {isPending ? (
              <span className='inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-800'>
                <MdWarning size={12} />
                {order?.orderStatus || "Pending"}
              </span>
            ) : (
              <StatusBadge status={order?.orderStatus || "Unknown"} />
            )}
            {order?.partialDelivery?.enabled && (
              <p className='mt-1 text-xs text-gray-500 dark:text-gray-400'>
                {getPartialDeliverySummary(order).delivered}/
                {getPartialDeliverySummary(order).ordered} delivered
              </p>
            )}
          </td>

          {/* Logistics */}
          <td className='py-4 px-3 whitespace-nowrap'>
            <LogisticsStatusBadge order={order} />
          </td>

          {/* Payment Status */}
          <td className='py-4 px-3 whitespace-nowrap'>
            <StatusBadge status={resolvePaymentStatus(order)} />
          </td>

          {/* Total */}
          <td className='py-4 px-3 whitespace-nowrap text-right'>
            <div className='text-sm font-bold text-gray-900 dark:text-white'>
              {typeof order?.total === "number" ? order.total.toFixed(2) : "0.00"}
            </div>
          </td>

          {/* Actions */}
          <td className='py-2 px-3 whitespace-nowrap'>
            <div className='space-y-2'>
              <div className='flex items-center gap-2'>
                <button
                  onClick={() => handleOpenInvoiceDialog(order)}
                  disabled={isPending}
                  className={`p-2 rounded-lg transition-all duration-200 ${
                    isPending
                      ? "text-gray-400 cursor-not-allowed opacity-50"
                      : "text-indigo-600 hover:text-indigo-700 hover:bg-indigo-100 dark:hover:bg-indigo-900/30"
                  }`}
                  title={isPending ? "Order pending verification/review" : "Edit Order"}
                >
                  <MdEdit size={18} />
                </button>
                {showTrackOrderButton && (
                  <button
                    onClick={() => handleOpenTrackingDialog(order)}
                    disabled={isPending}
                    className={`p-2 rounded-lg transition-all duration-200 ${
                      isPending
                        ? "text-gray-400 cursor-not-allowed opacity-50"
                        : "text-green-600 hover:text-green-700 hover:bg-green-100 dark:hover:bg-green-900/30"
                    }`}
                    title={isPending ? "Order pending verification/review" : "Track Order"}
                  >
                    <MdStore size={18} />
                  </button>
                )}
                {employeeDeliveryEnabled && renderDeliveryAssignmentControls(order)}
                {order?.orderStatus === "Pending return" && !isPending && (
                  <button
                    onClick={() => handleConfirmReturn(order)}
                    className='p-2 text-orange-600 hover:text-orange-700 hover:bg-orange-100 dark:hover:bg-orange-900/30 rounded-lg transition-all duration-200'
                    title={`Confirm Return${order?.returnReason ? ` — Reason: ${order.returnReason}` : ""}`}
                  >
                    <MdCheck size={18} />
                  </button>
                )}
              </div>
            
            </div>
          </td>
        </tr>
      );
    })
  )}
</tbody>
            </table>
          </div>
        </div>
      </div>
      {/* ============ UPDATED: INVOICE MODAL WITH VARIANT DISPLAY ============ */}
      <ModalComponent
        open={Boolean(assignmentDialogOrder)}
        onClose={() => setAssignmentDialogOrder(null)}
        title={t('DELIVERY.ASSIGN_DELIVERY_BATCH')}
        maxWidth='max-w-2xl'
        actions={[
          <button
            key='close'
            onClick={() => setAssignmentDialogOrder(null)}
            className='rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700'
          >
            Cancel
          </button>,
          <button
            key='assign'
            onClick={() =>
              assignmentDialogOrder &&
              handleAssignDeliveryTask(assignmentDialogOrder)
            }
            disabled={
              !assignmentDialogOrder ||
              assignmentDialogClosedOrder ||
              assigningOrderId === assignmentDialogOrder?.orderId ||
              !assignmentDialogSelectedEmployeeId ||
              assignmentDialogPendingBatchRows.length === 0 ||
              employees.length === 0
            }
            className='rounded-lg bg-indigo-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-gray-300 dark:disabled:bg-gray-600'
          >
            {assigningOrderId === assignmentDialogOrder?.orderId
              ? t('DELIVERY.ASSIGNING')
              : t('DELIVERY.ASSIGN_BATCH')}
          </button>,
        ]}
      >
        <div className='space-y-4'>
          <div className='rounded-2xl border border-indigo-100 bg-gradient-to-br from-indigo-50 to-white p-4 dark:border-indigo-900/50 dark:from-indigo-950/30 dark:to-gray-900'>
            <div className='flex items-start gap-3'>
              <div className='flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-600 text-white'>
                <MdLocalShipping size={18} />
              </div>
              <div>
                <div className='text-xs font-semibold uppercase tracking-[0.18em] text-indigo-500 dark:text-indigo-300'>
                  {t('DELIVERY.ORDER_LABEL')}
                </div>
                <div className='text-base font-semibold text-gray-900 dark:text-white'>
                  #{assignmentDialogOrder?.orderId || 'N/A'}
                </div>
                <div className='mt-1 text-sm text-gray-500 dark:text-gray-400'>
                  {assignmentDialogAssignedEmployeeName
                    ? t('DELIVERY.CURRENTLY_ASSIGNED_TO', { name: assignmentDialogAssignedEmployeeName })
                    : assignmentDialogClosedOrder
                      ? t('DELIVERY.NO_EMPLOYEE_ASSIGNED_DELIVERY')
                      : t('DELIVERY.NO_EMPLOYEE_ASSIGNED')}
                </div>
              </div>
            </div>
          </div>

          <div className='space-y-2'>
            <label className='text-xs font-semibold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400'>
              Select employee
            </label>
            <div className='relative'>
              <div className='pointer-events-none absolute inset-y-0 left-3 flex items-center text-indigo-400 dark:text-indigo-300'>
                <MdPersonOutline size={18} />
              </div>
              <select
                value={assignmentDialogSelectedEmployeeId}
                onChange={(event) =>
                  assignmentDialogOrder &&
                  setOrderAssignees((prev) => ({
                    ...prev,
                    [assignmentDialogOrder.orderId]: event.target.value,
                  }))
                }
                disabled={assignmentDialogClosedOrder || assigningOrderId === assignmentDialogOrder?.orderId}
                className='w-full appearance-none rounded-xl border border-gray-200 bg-white py-3 pl-10 pr-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:focus:border-indigo-400 dark:focus:ring-indigo-500/20 dark:disabled:bg-gray-700 dark:disabled:text-gray-500'
              >
                <option value=''>{t('DELIVERY.ASSIGN_EMPLOYEE')}</option>
                {employees.map((employee) => {
                  const employeeValue = employee?._id || employee?.employeeID || '';

                  return (
                    <option key={employeeValue} value={employeeValue}>
                      {employee?.employeeName || employee?.phoneNumber || 'Employee'}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className='rounded-xl border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-800/60'>
            <div className='mb-2 flex items-center justify-between'>
              <p className='text-xs font-semibold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400'>
                {t('DELIVERY.BATCH_QUANTITIES')}
              </p>
              <span className='text-xs font-medium text-gray-600 dark:text-gray-300'>
                {t('DELIVERY.SUMMARY_STATS', { delivered: assignmentDialogSummary.delivered, ordered: assignmentDialogSummary.ordered, pending: assignmentDialogSummary.pending })}
              </span>
            </div>

            <div className='space-y-2'>
              {assignmentDialogPendingBatchRows.map((row) => {
                const selectedQty = Math.max(
                  0,
                  Number(batchQuantities[row.itemKey] || 0),
                );
                const remainingAfterThis = Math.max(
                  0,
                  row.pendingQuantity - selectedQty,
                );

                return (
                <div
                  key={row.itemKey}
                  className='rounded-lg border border-gray-200 bg-white p-2 dark:border-gray-600 dark:bg-gray-900'
                >
                  <div className='flex items-start justify-between gap-2'>
                    <div>
                      <p className='text-sm font-semibold text-gray-800 dark:text-gray-100'>
                        {row.productName}
                      </p>
                      {row.variantName && (
                        <p className='text-xs text-indigo-600 dark:text-indigo-300'>
                          {row.variantName}
                        </p>
                      )}
                      <p className='mt-0.5 text-xs text-gray-500 dark:text-gray-400'>
                        {t('DELIVERY.ORDERED_LABEL')} {row.orderedQuantity} • {t('DELIVERY.DELIVERED_LABEL')} {row.deliveredQuantity} • {t('DELIVERY.PENDING_LABEL')} {row.pendingQuantity}
                      </p>
                      <p className='mt-0.5 text-xs text-gray-500 dark:text-gray-400'>
                        {t('DELIVERY.REMAINING_AFTER_BATCH', { count: remainingAfterThis })}
                      </p>
                      {row.lastDeliveredAt && (
                        <p className='mt-0.5 text-[11px] text-emerald-600 dark:text-emerald-300'>
                          Last delivered: {new Date(row.lastDeliveredAt).toLocaleString()}
                        </p>
                      )}
                      {remainingAfterThis > 0 && (
                        <div className='mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2'>
                          <input
                            type='date'
                            min={new Date().toISOString().split("T")[0]}
                            value={remainingDeliverySlots[row.itemKey]?.date || ""}
                            onChange={(event) => {
                              setRemainingDeliverySlots((prev) => ({
                                ...prev,
                                [row.itemKey]: {
                                  ...(prev[row.itemKey] || {}),
                                  date: event.target.value,
                                },
                              }));
                              setBatchAssignmentError("");
                            }}
                            disabled={assignmentDialogClosedOrder || assigningOrderId === assignmentDialogOrder?.orderId}
                            className='w-full rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:focus:ring-indigo-500/20 dark:disabled:bg-gray-700 dark:disabled:text-gray-500'
                            placeholder='Next delivery date'
                          />
                          <input
                            type='time'
                            value={remainingDeliverySlots[row.itemKey]?.time || ""}
                            onChange={(event) => {
                              setRemainingDeliverySlots((prev) => ({
                                ...prev,
                                [row.itemKey]: {
                                  ...(prev[row.itemKey] || {}),
                                  time: event.target.value,
                                },
                              }));
                              setBatchAssignmentError("");
                            }}
                            disabled={assignmentDialogClosedOrder || assigningOrderId === assignmentDialogOrder?.orderId}
                            className='w-full rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:focus:ring-indigo-500/20 dark:disabled:bg-gray-700 dark:disabled:text-gray-500'
                            placeholder='Next delivery time'
                          />
                        </div>
                      )}
                    </div>
                    <input
                      type='number'
                      min='0'
                      max={row.pendingQuantity}
                      value={batchQuantities[row.itemKey] ?? "0"}
                      onChange={(event) => {
                        const nextValue = event.target.value;
                        setBatchQuantities((prev) => ({
                          ...prev,
                          [row.itemKey]: nextValue,
                        }));
                        setBatchAssignmentError("");
                      }}
                      disabled={
                        assignmentDialogClosedOrder ||
                        assigningOrderId === assignmentDialogOrder?.orderId ||
                        row.pendingQuantity <= 0
                      }
                      className='w-20 rounded-md border border-gray-300 px-2 py-1 text-sm text-gray-700 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:focus:ring-indigo-500/20 dark:disabled:bg-gray-700 dark:disabled:text-gray-500'
                    />
                  </div>
                </div>
                );
              })}
              {!assignmentDialogPendingBatchRows.length && (
                <div className='rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs font-medium text-emerald-700 dark:border-emerald-900/60 dark:bg-emerald-950/40 dark:text-emerald-300'>
                  {t('DELIVERY.ALL_PRODUCTS_DELIVERED')}
                </div>
              )}
            </div>
          </div>

          {batchAssignmentError && (
            <p className='text-xs font-medium text-red-600 dark:text-red-400'>
              {batchAssignmentError}
            </p>
          )}

          <div className='flex flex-wrap items-center gap-2 text-xs'>
            {assignmentDialogSelectedEmployee && !assignmentDialogClosedOrder && (
              <span className='inline-flex rounded-full bg-indigo-50 px-3 py-1 font-medium text-indigo-700 ring-1 ring-indigo-100 dark:bg-indigo-900/30 dark:text-indigo-200 dark:ring-indigo-800'>
                {t('DELIVERY.SELECTED_EMPLOYEE', { name: assignmentDialogSelectedEmployee?.employeeName || assignmentDialogSelectedEmployee?.phoneNumber || 'Employee' })}
              </span>
            )}
            {assignmentDialogClosedOrder && (
              <span className='inline-flex rounded-full bg-gray-100 px-3 py-1 font-medium text-gray-600 ring-1 ring-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-700'>
                {t('DELIVERY.CLOSED_ORDERS_CANNOT_BE_REASSIGNED')}
              </span>
            )}
            {!employees.length && (
              <span className='inline-flex rounded-full bg-amber-50 px-3 py-1 font-medium text-amber-700 ring-1 ring-amber-100 dark:bg-amber-900/30 dark:text-amber-200 dark:ring-amber-800'>
                {t('DELIVERY.NO_EMPLOYEES_AVAILABLE')}
              </span>
            )}
          </div>
        </div>
      </ModalComponent>

      {/* Return Confirmation Modal */}
      <ModalComponent
        open={returnConfirmDialogOpen}
        onClose={() => {
          setReturnConfirmDialogOpen(false);
          setReturnOrderToConfirm(null);
        }}
        title="Visit Store for Return"
        maxWidth="max-w-md"
        actions={[
          <button
            key="confirm_only"
            onClick={() => handleFinalConfirmReturn(returnOrderToConfirm, false)}
            className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
          >
            Just Confirm Return
          </button>,
          <button
            key="assign_pickup"
            onClick={() => handleFinalConfirmReturn(returnOrderToConfirm, true)}
            className="rounded-lg bg-orange-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-orange-700 shadow-md"
          >
            Assign Pickup Task
          </button>,
        ]}
      >
        <div className="space-y-4 p-2 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400 mb-2">
            <MdStore size={32} />
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white uppercase tracking-tight">
            Visit Store For Return
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            Please inform the customer to visit the store for returning their items.
          </p>
          <div className="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
             <p className="text-xs text-gray-500 dark:text-gray-500 italic">
               Alternatively, you can assign an employee to go and pick up the products from the customer's location.
             </p>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        open={invoiceDialogOpen}
        onClose={handleCloseInvoiceDialog}
        title={t("RESELLER_ORDERS.ORDER_DETAILS")}
        maxWidth='max-w-3xl'
        className='text-gray-900 dark:text-gray-100'
        actions={[
          <button
            key='cancel'
            onClick={handleCloseInvoiceDialog}
            className='px-2.5 py-1 rounded-md bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-xs font-medium text-gray-800 dark:text-gray-200 transition-colors shadow-sm'
          >
            {t("COMMONONE.CANCEL")}
          </button>,
          // <button
          //   key='create'
          //   disabled={
          //     selectedOrder?.isInvoiceCreated ||
          //     !isOrderFullyDeliveredForInvoice(selectedOrder)
          //   }
          //   onClick={handleCreateInvoice}
          //   title={
          //     selectedOrder?.isInvoiceCreated
          //       ? "Invoice already created"
          //       : isOrderFullyDeliveredForInvoice(selectedOrder)
          //         ? "Create invoice"
          //         : "Invoice is allowed only after full delivery"
          //   }
          //   className='px-2.5 py-1 rounded-md bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors shadow-sm disabled:opacity-60'
          // >
          //   {t("ONLINE_STORE.CREATE_INVOICE")}
          // </button>,
          <button
            key='update'
            onClick={handleUpdateOrder}
            className='px-2.5 py-1 rounded-md bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors shadow-sm'
          >
            {t("ONLINE_STORE.UPDATE_ORDER")}
          </button>,
        ]}
      >
        {selectedOrder && (
          <div className='space-y-2 text-[11px] scale-95 bg-white dark:bg-gray-900 p-1 rounded'>
            <div className='bg-blue-50 dark:bg-blue-900/40 p-1.5 rounded border border-blue-100 dark:border-blue-700'>
              <div className='grid grid-cols-3 gap-2'>
                <div>
                  <p className='text-[10px] text-gray-500 dark:text-gray-400'>
                    {t("ONLINE_STORE.ORDER")} #
                  </p>
                  <p className='font-semibold text-blue-800 dark:text-blue-300 text-xs'>
                    {selectedOrder.orderId}
                  </p>
                </div>
                <div>
                  <p className='text-[10px] text-gray-500 dark:text-gray-400'>
                    {t("ONLINE_STORE.DATE")}
                  </p>
                  <p className='text-xs text-gray-900 dark:text-gray-200'>
                    {selectedOrder.orderDate}
                  </p>
                </div>
                <div>
                  <p className='text-[10px] text-gray-500 dark:text-gray-400'>
                    {t("FORM.SALE_TYPE")}
                  </p>
                  <select
                    value={selectedOrder.saleType}
                    onChange={(e) =>
                      setSelectedOrder({
                        ...selectedOrder,
                        saleType: e.target.value,
                      })
                    }
                    className='mt-0.5 w-full text-[11px] rounded border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200 focus:ring-indigo-500 focus:border-indigo-500 py-0.5'
                  >
                    <option value='confirmSale'>Confirm Sale</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='grid grid-cols-2 gap-2'>
              <div className='bg-gray-50 dark:bg-gray-800 p-1.5 rounded border border-gray-100 dark:border-gray-700'>
                <h3 className='text-[11px] font-semibold text-gray-800 dark:text-gray-200 mb-1 border-b border-gray-200 dark:border-gray-600 pb-0.5'>
                  {t("SALESIDEBAR.CUSTOMER_INFORMATION")}
                </h3>
                <p className='font-medium text-xs text-gray-900 dark:text-gray-100'>
                  {selectedOrder.customerName}
                </p>
                <p className='text-gray-600 dark:text-gray-400 text-[11px]'>
                  {selectedOrder.customerEmail || "No email provided"}
                </p>
                <p className='text-gray-600 dark:text-gray-400 text-[11px]'>
                  {selectedOrder.phone}
                </p>
              </div>

              <div className='bg-gray-50 dark:bg-gray-800 p-1.5 rounded border border-gray-100 dark:border-gray-700'>
                <h3 className='text-[11px] font-semibold text-gray-800 dark:text-gray-200 mb-1 border-b border-gray-200 dark:border-gray-600 pb-0.5'>
                  {t("PROFILE.BUSINESS_ADDRESS")}
                </h3>
                <p className='break-words text-[11px] text-gray-900 dark:text-gray-200'>
                  {selectedOrder.address || "No address provided"}
                </p>
              </div>
            </div>

            <div className='grid grid-cols-2 gap-2'>
              <div>
                <p className='text-[11px] text-gray-500 dark:text-gray-400'>
                  Order Status
                </p>
                <select
                  value={selectedOrder.orderStatus}
                  onChange={(e) => {
                    const nextStatus = e.target.value;

                    setSelectedOrder({
                      ...selectedOrder,
                      orderStatus: nextStatus,
                    });

                    if (nextStatus !== "Delayed") {
                      setDelaySlotError("");
                    }
                  }}
                  className='w-full text-[11px] rounded border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200'
                >
                  <option value='Ordered'>{t("ONLINE_STORE.ORDERED")}</option>
                  <option value='Approved'>Approved</option>
                  <option value='Confirmed'>
                    {t("ONLINE_STORE.CONFIRMED")}
                  </option>
                  <option value='Delayed'>Delayed</option>
                  <option value='Processing'>
                    {t("ONLINE_STORE.PROCESSING")}
                  </option>
                  <option value='Shipped'>{t("ONLINE_STORE.SHIPPED")}</option>
                  <option value='Partially Delivered'>Partially Delivered</option>
                  {/* <option value='Delivered'>
                    {t("ONLINE_STORE.DELIVERED")}
                  </option> */}
                  <option value='Cancelled'>
                    {t("ONLINE_STORE.CANCELLED")}
                  </option>
                  <option value='Pending return'>Pending return</option>
                  <option value='Confirm return'>Confirm return</option>
                  <option value='Returned'>Returned</option>
                </select>
              </div>
              <div>
                <p className='text-[11px] text-gray-500 dark:text-gray-400'>
                  Payment Method
                </p>
                <p className='font-medium text-xs text-gray-900 dark:text-gray-200'>
                  {selectedOrder.paymentMode || "pending"}
                </p>
              </div>
            </div>

            {(hasPreferredDeliverySlot || isDelayedOrderSelected) && (
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-2'>
                {hasPreferredDeliverySlot && (
                  <div className='bg-amber-50 dark:bg-amber-900/20 p-2 rounded border border-amber-100 dark:border-amber-800'>
                    <p className='text-[10px] font-semibold text-amber-700 dark:text-amber-300 uppercase tracking-wide'>
                      Preferred delivery slot
                    </p>
                    <p className='mt-1 text-xs text-amber-900 dark:text-amber-100'>
                      {formatPreferredDeliverySlot(selectedOrder)}
                    </p>
                  </div>
                )}

                {isDelayedOrderSelected && (
                  <div className='bg-blue-50 dark:bg-blue-900/20 p-2 rounded border border-blue-100 dark:border-blue-800'>
                    <p className='text-[10px] font-semibold text-blue-700 dark:text-blue-300 uppercase tracking-wide'>
                      Updated delivery slot
                    </p>
                    <p className='mt-1 text-xs text-blue-900 dark:text-blue-100'>
                      {formatRevisedDeliverySlot(selectedOrder)}
                    </p>
                  </div>
                )}
              </div>
            )}

            {isDelayedOrderSelected && (
              <div className='rounded border border-orange-200 dark:border-orange-800 bg-orange-50 dark:bg-orange-900/20 p-2 space-y-2'>
                <div>
                  <p className='text-[11px] font-semibold text-orange-800 dark:text-orange-300'>
                    Updated delivery date and time
                  </p>
                  <p className='text-[10px] text-orange-700 dark:text-orange-200 mt-0.5'>
                    This is sent to the customer in order history and push notification.
                  </p>
                </div>
                <div className='grid grid-cols-1 sm:grid-cols-2 gap-2'>
                  <div>
                    <label className='block text-[11px] text-gray-600 dark:text-gray-300 mb-1'>
                      Updated date
                    </label>
                    <input
                      type='date'
                      min={new Date().toISOString().split("T")[0]}
                      value={selectedOrder.revisedDeliveryDate || ''}
                      onChange={(e) => {
                        setSelectedOrder({
                          ...selectedOrder,
                          revisedDeliveryDate: e.target.value,
                        });
                        setDelaySlotError("");
                      }}
                      className='w-full text-[11px] rounded border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200'
                    />
                  </div>
                  <div>
                    <label className='block text-[11px] text-gray-600 dark:text-gray-300 mb-1'>
                      Updated time
                    </label>
                    <input
                      type='time'
                      value={selectedOrder.revisedDeliveryTime || ''}
                      onChange={(e) => {
                        setSelectedOrder({
                          ...selectedOrder,
                          revisedDeliveryTime: e.target.value,
                        });
                        setDelaySlotError("");
                      }}
                      className='w-full text-[11px] rounded border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200'
                    />
                  </div>
                </div>
                {delaySlotError && (
                  <p className='text-[11px] text-red-600 dark:text-red-400'>
                    {delaySlotError}
                  </p>
                )}
              </div>
            )}

            <div>
              <h3 className='text-[11px] font-semibold text-gray-800 dark:text-gray-200 mb-1'>
                {t("COMMON.PRODUCT")}
              </h3>
              <div className='overflow-hidden border border-gray-200 dark:border-gray-700 rounded'>
                <div className='max-h-40 overflow-y-auto'>
                  <table className='min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-[11px]'>
                    <thead className='bg-gray-50 dark:bg-gray-800 sticky top-0'>
                      <tr>
                        <th className='px-2 py-1 text-left font-medium text-gray-500 dark:text-gray-400 uppercase w-6/12'>
                          {t("ONLINE_STORE.PRODUCT_VARIANT")}
                        </th>
                        <th className='px-2 py-1 text-left font-medium text-gray-500 dark:text-gray-400 uppercase w-2/12'>
                          {t("COMMON.QTY")}
                        </th>
                        <th className='px-2 py-1 text-left font-medium text-gray-500 dark:text-gray-400 uppercase w-2/12'>
                          "{t("DASHBOARD.PRICE")}"
                        </th>
                        <th className='px-2 py-1 text-left font-medium text-gray-500 dark:text-gray-400 uppercase w-2/12'>
                          {t("COMMON.TOTAL")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className='bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700'>
                      {selectedOrder.items?.map((product, index) => {
                        // Check if this is a variant product based on your schema
                        const hasVariants =
                          product.variantId ||
                          (product.variants && product.variants.length > 0) ||
                          (product.attributes && product.attributes.length > 0);

                        // Get variant details - handle different possible structures
                        let variantName = "";
                        let variantAttributes = [];
                        let variantId = "";

                        // Case 1: Direct variant fields on the product (most common in orders)
                        if (product.variantId) {
                          variantId = product.variantId;
                          variantName = product.variantName || "";

                          // If attributes array exists directly on product
                          if (
                            product.attributes &&
                            Array.isArray(product.attributes)
                          ) {
                            variantAttributes = product.attributes;
                          }
                        }

                        // Case 2: Variants array (if product has multiple variants, but in orders usually one variant per line item)
                        if (
                          !variantId &&
                          product.variants &&
                          Array.isArray(product.variants) &&
                          product.variants.length > 0
                        ) {
                          const variantData = product.variants[0]; // Usually first variant for this line item
                          variantId = variantData.variantId || "";
                          variantName = variantData.variantName || "";

                          if (
                            variantData.attributes &&
                            Array.isArray(variantData.attributes)
                          ) {
                            variantAttributes = variantData.attributes;
                          }
                        }

                        // Format attributes for display
                        const formatAttributes = (attrs) => {
                          if (!attrs || attrs.length === 0) return "";
                          return attrs
                            .map((attr) => {
                              // Handle different attribute structures
                              if (attr.type && attr.value) {
                                return `${attr.type}: ${attr.value}`;
                              } else if (attr.name && attr.value) {
                                return `${attr.name}: ${attr.value}`;
                              } else if (typeof attr === "object") {
                                const key = Object.keys(attr)[0];
                                return `${key}: ${attr[key]}`;
                              }
                              return "";
                            })
                            .filter(Boolean)
                            .join(", ");
                        };

                        // Generate variant display name from attributes if variantName not available
                        let displayVariantName = variantName;
                        if (
                          !displayVariantName &&
                          variantAttributes.length > 0
                        ) {
                          displayVariantName =
                            formatAttributes(variantAttributes);
                        }

                        // Generate unique key for this product-variant combination
                        const uniqueKey = variantId
                          ? `${product.productId || product._id}_${variantId}_${index}`
                          : `${product.productId || product._id}_${index}`;

                        const unitPrice = isB2BMode
                          ? Number(
                              product.b2bSalePrice || product.salePrice || 0,
                            )
                          : Number(product.salePrice || 0);

                        const quantity = Number(
                          product.cartQuantity || product.quantity || 1,
                        );
                        const totalPrice = (quantity * unitPrice).toFixed(2);

                        return (
                          <tr
                            key={uniqueKey}
                            className='hover:bg-gray-50 dark:hover:bg-gray-700'
                          >
                            <td className='px-2 py-0.5'>
                              <div className='flex items-start'>
                                <div className='h-4 w-4 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center text-[7px] text-gray-500 dark:text-gray-300 flex-shrink-0 mr-2 mt-0.5'>
                                  Img
                                </div>
                                <div className='min-w-0 flex-1'>
                                  <div
                                    className='font-medium text-[11px] break-words text-gray-900 dark:text-gray-100'
                                    title={product.productName}
                                  >
                                    {product.productName}
                                  </div>

                                  {/* Display variant information if available */}
                                  {hasVariants && (
                                    <div className='mt-0.5 space-y-0.5'>
                                      {variantName && (
                                        <div className='text-[10px] text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900 px-1 py-0.5 rounded inline-block mr-1'>
                                          {variantName}
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  {/* Show variant count badge */}
                                  {hasVariants && !variantName && (
                                    <div className='mt-0.5 text-[9px] text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900 px-1 py-0.5 rounded inline-block'>
                                      Has Variants
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>

                            <td className='px-2 py-0.5 text-gray-600 dark:text-gray-300'>
                              {quantity}
                            </td>
                            <td className='px-2 py-0.5 text-gray-600 dark:text-gray-300'>
                              {getCurrencySymbol(business?.currency)}
                              {unitPrice.toFixed(2)}
                            </td>
                            <td className='px-2 py-0.5 font-medium text-gray-900 dark:text-gray-100'>
                              {getCurrencySymbol(business?.currency)}
                              {totalPrice}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-2'>
              {/* Summary Card */}
              <div className='bg-blue-50 dark:bg-blue-900/30 p-1.5 rounded border border-blue-100 dark:border-blue-800'>
                <h3 className='text-[11px] font-semibold text-blue-800 dark:text-blue-300 mb-1'>
                  {t("REPORT.SUMMERY")}
                </h3>

                {(() => {
                  const subtotal =
                    selectedOrder.items?.reduce((acc, product) => {
                      const qty = Number(product.cartQuantity || 1);
                      const price = isB2BMode
                        ? Number(product.b2bSalePrice || product.salePrice || 0)
                        : Number(product.salePrice || 0);
                      return acc + qty * price;
                    }, 0) || 0;

                  const shipping = Number(
                    selectedOrder.shippingCost ||
                      selectedOrder.deliveryCharge ||
                      0,
                  );
                  const tax = Math.max(
                    (selectedOrder.total || 0) - subtotal - shipping,
                    0,
                  );

                  return (
                    <div className='space-y-0.5 text-[11px] text-gray-900 dark:text-gray-100'>
                      <div className='flex justify-between'>
                        <span>{t("ONLINE_STORE.SUB_TOTAL")}:</span>
                        <span className='font-medium'>
                          {getCurrencySymbol(business?.currency)}
                          {subtotal.toFixed(2)}
                        </span>
                      </div>
                      <div className='flex justify-between'>
                        <span>{t("ONLINE_STORE.TAX")}:</span>
                        <span className='font-medium'>
                          {getCurrencySymbol(business?.currency)}
                          {tax.toFixed(2)}
                        </span>
                      </div>
                      <div className='flex justify-between'>
                        <span>{t("ONLINE_STORE.SHIPPING")}:</span>
                        <span className='font-medium'>
                          {getCurrencySymbol(business?.currency)}
                          {shipping.toFixed(2)}
                        </span>
                      </div>
                      <div className='flex justify-between border-t border-gray-200 dark:border-gray-700 pt-1 mt-1'>
                        <span className='font-bold'>
                          {t("CART_MODEL.TOTAL")}:
                        </span>
                        <span className='font-bold text-blue-800 dark:text-blue-300'>
                          {getCurrencySymbol(business?.currency)}
                          {(selectedOrder.total || 0).toFixed(2)}
                        </span>
                      </div>
                      
                  
                    </div>
                  );
                })()}
              </div>

              {/* Notes */}
              <div>
                <label
                  htmlFor='invoiceNotes'
                  className='block font-medium mb-0.5 text-[11px] text-gray-800 dark:text-gray-200'
                >
                  {t("ONLINE_STORE.NOTES")}
                </label>
                <textarea
                  id='invoiceNotes'
                  rows={2}
                  className='w-full px-1.5 py-1 border border-gray-300 dark:border-gray-600 rounded focus:ring-1 focus:ring-indigo-500 dark:focus:ring-indigo-400 focus:border-indigo-500 dark:focus:border-indigo-400 text-[11px] bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100'
                  placeholder={t("ONLINE_STORE.ADD_NOTES")}
                />
              </div>
            </div>
          </div>
        )}
      </ModalComponent>
      {/* ============ END UPDATED INVOICE MODAL ============ */}
      <ModalComponent
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        title='Store Settings'
        maxWidth='max-w-6xl'
        actions={[
          <button
            key='cancel'
            onClick={() => setSettingsOpen(false)}
            className='px-5 py-2.5 text-gray-700 border-2 border-gray-300 rounded-xl font-semibold hover:bg-gray-100 transition-colors'
          >
            {t("COMMONONE.CANCEL")}
          </button>,
          <button
            key='save'
            onClick={handleSave}
            disabled={uploadingBanner}
            className={`px-5 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold hover:from-indigo-700 hover:to-purple-700 transition-colors shadow-md ${
              uploadingBanner ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {uploadingBanner
              ? t("ONLINE_STORE.UPLOADING")
              : t("ONLINE_STORE.SAVE_ALL_CHANGES")}
          </button>,
        ]}
      >
        <div className='space-y-6'>
          <div className='border-b border-gray-200 dark:border-gray-700'>
            <nav className='-mb-px flex space-x-1 overflow-x-auto'>
              <button
                onClick={() => setActiveSettingsTab("general")}
                className={`py-3 px-6 font-medium text-sm rounded-t-lg transition-all whitespace-nowrap ${
                  activeSettingsTab === "general"
                    ? "border-b-2 border-indigo-500 bg-white dark:bg-gray-800 text-indigo-600 dark:text-indigo-400 shadow-sm"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                <div className='flex items-center gap-2'>
                  <MdSettings size={18} />
                  {t("SETTINGS.GENERAL")}
                </div>
              </button>
              <button
                onClick={() => setActiveSettingsTab("theme")}
                className={`py-3 px-6 font-medium text-sm rounded-t-lg transition-all whitespace-nowrap ${
                  activeSettingsTab === "theme"
                    ? "border-b-2 border-purple-500 bg-white dark:bg-gray-800 text-purple-600 dark:text-purple-400 shadow-sm"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                <div className='flex items-center gap-2'>
                  <MdPalette size={18} />
                  {t("SETTINGS.THEME")}
                </div>
              </button>
              <button
                onClick={() => setActiveSettingsTab("banner")}
                className={`py-3 px-6 font-medium text-sm rounded-t-lg transition-all whitespace-nowrap ${
                  activeSettingsTab === "banner"
                    ? "border-b-2 border-pink-500 bg-white dark:bg-gray-800 text-pink-600 dark:text-pink-400 shadow-sm"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                <div className='flex items-center gap-2'>
                  <MdWallpaper size={18} />
                  {t("SETTINGS.BANNER")}
                </div>
              </button>
              <button
                onClick={() => setActiveSettingsTab("layout")}
                className={`py-3 px-6 font-medium text-sm rounded-t-lg transition-all whitespace-nowrap ${
                  activeSettingsTab === "layout"
                    ? "border-b-2 border-amber-500 bg-white dark:bg-gray-800 text-amber-600 dark:text-amber-400 shadow-sm"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                <div className='flex items-center gap-2'>
                  <MdHome size={18} />
                  {t("SETTINGS.LAYOUT")}
                </div>
              </button>
              <button
                onClick={() => setActiveSettingsTab("reviews")}
                className={`py-3 px-6 font-medium text-sm rounded-t-lg transition-all whitespace-nowrap ${
                  activeSettingsTab === "reviews"
                    ? "border-b-2 border-green-500 bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 shadow-sm"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                <div className='flex items-center gap-2 relative'>
                  <MdReviews size={18} />
                  {t("SETTINGS.REVIEWS")}
                  {pendingReviewsCount > 0 && (
                    <span className='absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center'>
                      {pendingReviewsCount}
                    </span>
                  )}
                </div>
              </button>
            </nav>
          </div>

          <div className='min-h-[500px]'>
            {activeSettingsTab === "general" && (
              <div className='space-y-8 animate-fadeIn'>
                <div>
                  <h3 className='text-2xl font-bold text-gray-900 dark:text-white mb-2'>
                    {t("SETTINGS.GENERAL_SETTINGS")}
                  </h3>
                  <p className='text-gray-600 dark:text-gray-400'>
                    {t("SETTINGS.GENERAL_SETTINGS_DESCRIPTION")}
                  </p>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <label
                    htmlFor='storeDescription'
                    className='block text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3'
                  >
                    {t("SETTINGS.STORE_DESCRIPTION")}
                  </label>
                  <textarea
                    id='storeDescription'
                    rows={6}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className='mt-1 block w-full border-2 border-gray-300 dark:border-gray-600 rounded-xl shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-base bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100'
                    placeholder={t("SETTINGS.STORE_DESCRIPTION_PLACEHOLDER")}
                  />
                  <div className='mt-4 flex justify-between items-center'>
                    <p className='text-sm text-gray-500 dark:text-gray-400'>
                      {t("SETTINGS.STORE_DESCRIPTION_NOTE")}
                    </p>
                  </div>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
  <div className='flex items-start justify-between gap-4'>
    <div>
      <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-1'>
        {t("NEWSLETTER.CASH_ON_DELIVERY", "Cash on Delivery")}
      </h4>
      <p className='text-sm text-gray-600 dark:text-gray-400'>
        {t("NEWSLETTER.CASH_ON_DELIVERY_DESC", "Show or hide the Cash on Delivery option for customers at checkout.")}
      </p>
    </div>
    <label className='relative inline-flex items-center cursor-pointer'>
      <input
        type='checkbox'
        className='sr-only peer'
        checked={cashOnDeliveryEnabled}
        onChange={(e) => setCashOnDeliveryEnabled(e.target.checked)}
      />
      <div
        className={`w-11 h-6 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full ${
          cashOnDeliveryEnabled
            ? "bg-emerald-500 after:border-emerald-500"
            : "bg-gray-300 dark:bg-gray-600 after:border-gray-300 dark:after:border-gray-500"
        }`}
      ></div>
    </label>
  </div>
  <div
    className={`mt-4 inline-flex items-center rounded-lg px-3 py-2 text-sm font-medium ${
      cashOnDeliveryEnabled
        ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300"
        : "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300"
    }`}
  >
    {cashOnDeliveryEnabled
      ? t("NEWSLETTER.VISIBLE_TO_CUSTOMERS", "Visible to customers at checkout")
      : t("NEWSLETTER.HIDDEN_FROM_CUSTOMERS", "Hidden from customers at checkout")}
  </div>

  <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm mt-6'>
    <div className='flex items-center justify-between mb-4'>
      <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200'>
        {t("NEWSLETTER.CALL_WHATSAPP_SETTINGS", "Call & WhatsApp Settings")}
      </h4>
    </div>
    
    <div className='space-y-4'>
      {/* Call Button Toggle */}
      <div className='flex items-center justify-between'>
        <div>
          <p className='font-medium text-gray-700 dark:text-gray-300'>
            {t("NEWSLETTER.SHOW_CALL_BUTTON", "Show Call Button")}
          </p>
          <p className='text-sm text-gray-500 dark:text-gray-400'>
            {t("NEWSLETTER.SHOW_CALL_BUTTON_DESC", "Display call button in storefront footer")}
          </p>
        </div>
        <label className='relative inline-flex items-center cursor-pointer'>
          <input
            type='checkbox'
            className='sr-only peer'
            checked={showCallButton}
            onChange={(e) => setShowCallButton(e.target.checked)}
          />
          <div className={`w-11 h-6 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full ${
            showCallButton
              ? "bg-green-500 after:border-green-500"
              : "bg-gray-300 dark:bg-gray-600 after:border-gray-300 dark:after:border-gray-500"
          }`}></div>
        </label>
      </div>

      {/* Call Phone Number (appears when showCallButton is true) */}
      {showCallButton && (
        <div>
          <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
            {t("NEWSLETTER.CALL_PHONE_NUMBER", "Call Phone Number")}
          </label>
          <input
            type='tel'
            value={callPhoneNumber}
            onChange={(e) => setCallPhoneNumber(e.target.value)}
            placeholder='+91XXXXXXXXXX'
            className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
          />
          <p className='text-xs text-gray-500 dark:text-gray-400 mt-1'>
            {t("NEWSLETTER.PHONE_NUMBER_HINT", "Enter phone number with country code")}
          </p>
        </div>
      )}

      {/* Divider */}
      <div className='border-t border-gray-200 dark:border-gray-700 my-4'></div>

      {/* WhatsApp Button Toggle */}
      <div className='flex items-center justify-between'>
        <div>
          <p className='font-medium text-gray-700 dark:text-gray-300'>
            {t("NEWSLETTER.SHOW_WHATSAPP_BUTTON", "Show WhatsApp Button")}
          </p>
          <p className='text-sm text-gray-500 dark:text-gray-400'>
            {t("NEWSLETTER.SHOW_WHATSAPP_BUTTON_DESC", "Display WhatsApp chat button in storefront footer")}
          </p>
        </div>
        <label className='relative inline-flex items-center cursor-pointer'>
          <input
            type='checkbox'
            className='sr-only peer'
            checked={showWhatsappButton}
            onChange={(e) => setShowWhatsappButton(e.target.checked)}
          />
          <div className={`w-11 h-6 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full ${
            showWhatsappButton
              ? "bg-green-500 after:border-green-500"
              : "bg-gray-300 dark:bg-gray-600 after:border-gray-300 dark:after:border-gray-500"
          }`}></div>
        </label>
      </div>

      {/* WhatsApp Number (appears when showWhatsappButton is true) */}
      {showWhatsappButton && (
        <>
          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
              {t("NEWSLETTER.WHATSAPP_NUMBER", "WhatsApp Number")}
            </label>
            <input
              type='tel'
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              placeholder='+91XXXXXXXXXX'
              className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
            />
            <p className='text-xs text-gray-500 dark:text-gray-400 mt-1'>
              {t("NEWSLETTER.PHONE_NUMBER_HINT", "Enter phone number with country code")}
            </p>
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
              {t("NEWSLETTER.WHATSAPP_PREFILLED_MESSAGE", "WhatsApp Pre-filled Message")}
            </label>
            <textarea
              rows={2}
              value={whatsappMessage}
              onChange={(e) => setWhatsappMessage(e.target.value)}
              placeholder={t("NEWSLETTER.WHATSAPP_MESSAGE_PLACEHOLDER", "Hi! I am interested in your products.")}
              className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
            />
          </div>
        </>
      )}
    </div>
  </div>
</div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3'>
                    {t("SETTINGS.STORE_URL_QR")}
                  </h4>
                  <div className='flex items-center gap-2 mb-4'>
                    <div className='flex-1 bg-gray-50 dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-3'>
                      <code className='text-gray-700 dark:text-gray-300 break-all'>
                        {storeUrl}
                      </code>
                    </div>
                    <button
                      onClick={handleCopy}
                      className={`px-4 py-3 rounded-lg font-medium transition-colors ${
                        copied
                          ? "bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800"
                          : "bg-indigo-600 text-white hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
                      }`}
                    >
                      {copied ? t("COMMONONE.COPIED") : t("COMMONONE.COPY")}
                    </button>
                  </div>

                  <div className='flex justify-center'>
                    <button
                      onClick={() => {
                        setSettingsOpen(false);
                        setTimeout(() => setQrModalOpen(true), 300);
                      }}
                      className='flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:from-purple-700 hover:to-pink-700 transition-all shadow-md'
                    >
                      <MdQrCode size={20} />
                      {t("SETTINGS.GENERATE_QR_CODE")}
                    </button>
                  </div>

                  <p className='mt-4 text-sm text-gray-500 dark:text-gray-400 text-center'>
                    {t("SETTINGS.SHARE_STORE_LINK")}
                  </p>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                    {t("SETTINGS.STORE_STATUS")}
                  </h4>
                  <div className='flex items-center gap-4'>
                    <div
                      className={`px-4 py-2 rounded-lg font-medium ${
                        layoutSettings?.showLanding !== false
                          ? "bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400"
                          : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-400"
                      }`}
                    >
                      {layoutSettings?.showLanding !== false
                        ? "🟢 " + t("SETTINGS.LIVE")
                        : "🔴 " + t("SETTINGS.OFFLINE")}
                    </div>
                    <div className='text-sm text-gray-600 dark:text-gray-400'>
                      {t("SETTINGS.STORE_CURRENTLY")}{" "}
                      {layoutSettings?.showLanding !== false
                        ? t("SETTINGS.VISIBLE_TO_CUSTOMERS")
                        : t("SETTINGS.HIDDEN_FROM_PUBLIC")}
                    </div>
                  </div>
                </div>
{/* 
                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <div className='flex items-start justify-between gap-4 flex-wrap'>
                    <div>
                      <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-1'>
                        Meta Commerce (Facebook / Instagram)
                      </h4>
                      <p className='text-sm text-gray-600 dark:text-gray-400'>
                        Connect your Facebook &amp; Instagram account to sync
                        your product catalog and track ad performance.
                      </p>
                    </div>
                  </div>
                  <div className='mt-4 flex items-center gap-4 flex-wrap'>
                    <div
                      className={`px-3 py-1.5 rounded-full text-sm font-semibold ${metaStatus.enabled ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" : "bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400"}`}
                    >
                      {metaLoading
                        ? "Checking..."
                        : metaStatus.enabled
                          ? "● Connected"
                          : "○ Not connected"}
                    </div>
                    <button
                      onClick={() =>
                        navigate(`/${bussinessUuid}/dashboard/meta-growth`)
                      }
                      className='inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#1877F2] text-white text-sm font-semibold hover:bg-blue-600 transition'
                    >
                      <MdLink size={16} />{" "}
                      {metaStatus.enabled
                        ? "Manage Meta Integration"
                        : "Connect Meta"}
                    </button>
                  </div>
                  <p className='text-xs text-gray-400 dark:text-gray-500 mt-3'>
                    Meta integration is managed from the{" "}
                    <strong>Meta Growth</strong> page in the sidebar.
                  </p>
                </div> */}
              </div>
            )}

            {activeSettingsTab === "theme" && (
              <div className='space-y-8 animate-fadeIn'>
                <div>
                  <h3 className='text-2xl font-bold text-gray-900 dark:text-white mb-2'>
                    {t("SETTINGS.THEME_SETTINGS")}
                  </h3>
                  <p className='text-gray-600 dark:text-gray-400'>
                    {t("SETTINGS.THEME_SETTINGS_DESCRIPTION")}
                  </p>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <div className='flex items-center justify-between mb-4'>
                    <div>
                      <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200'>
                        {t("SETTINGS.CHOOSE_THEME")}
                      </h4>
                      <p className='text-gray-600 dark:text-gray-400'>
                        {t("SETTINGS.CHOOSE_THEME_DESCRIPTION")}
                      </p>
                    </div>
                    <div className='text-sm text-gray-500 dark:text-gray-400'>
                      {allPredefinedThemes.length}{" "}
                      {t("SETTINGS.THEMES_AVAILABLE")}
                    </div>
                  </div>

                  <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                    {allPredefinedThemes.map((theme) => (
                      <div
                        key={theme.name}
                        className={`border-2 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl cursor-pointer ${
                          storeTheme?.themeName === theme.name ||
                          (storeTheme?.themeId &&
                            storeTheme?.themeId === (theme.themeId || theme.id))
                            ? "border-indigo-500 dark:border-indigo-400 ring-2 ring-indigo-200 dark:ring-indigo-900"
                            : "border-gray-200 dark:border-gray-700 hover:border-indigo-300 dark:hover:border-indigo-600"
                        }`}
                        onClick={() => {
                          handleSaveTheme(theme);
                          toast.success(
                            t("SETTINGS.THEME_APPLIED", { name: theme.name }),
                          );
                        }}
                      >
                        <div
                          className='h-32 p-4 relative'
                          style={{
                            backgroundColor: theme.backgroundColor,
                            backgroundImage: theme.themePreviewImage
                              ? `linear-gradient(rgba(17, 24, 39, 0.28), rgba(17, 24, 39, 0.18)), url(${theme.themePreviewImage})`
                              : undefined,
                            backgroundSize: theme.themePreviewImage
                              ? "cover"
                              : undefined,
                            backgroundPosition: theme.themePreviewImage
                              ? "center"
                              : undefined,
                          }}
                        >
                          <div className='absolute top-4 left-4'>
                            <div
                              className='font-bold text-sm'
                              style={{
                                color: theme.themePreviewImage
                                  ? "#ffffff"
                                  : theme.headingColor,
                                fontFamily: theme.fontFamily,
                                textShadow: theme.themePreviewImage
                                  ? "0 1px 3px rgba(0, 0, 0, 0.35)"
                                  : "none",
                              }}
                            >
                              {theme.name}
                            </div>
                          </div>

                          <div className='absolute bottom-4 left-4 right-4 space-y-2'>
                            <div
                              className='h-6 rounded-lg'
                              style={{
                                backgroundColor: theme.buttonColor,
                                borderRadius:
                                  theme.buttonStyle === "pill"
                                    ? "9999px"
                                    : theme.buttonStyle === "square"
                                      ? "4px"
                                      : "8px",
                              }}
                            ></div>
                            <div className='flex gap-1'>
                              <div
                                className='flex-1 h-3 rounded'
                                style={{
                                  backgroundColor: theme.primaryColor + "40",
                                }}
                              ></div>
                              <div
                                className='flex-1 h-3 rounded'
                                style={{
                                  backgroundColor: theme.secondaryColor + "40",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div className='p-4 bg-white dark:bg-gray-800'>
                          <div className='flex justify-between items-center mb-3'>
                            <div className='text-sm font-medium text-gray-900 dark:text-white'>
                              {theme.name}
                            </div>
                          </div>

                          <div className='flex gap-1 mb-3'>
                            {[
                              theme.primaryColor,
                              theme.buttonColor,
                              theme.backgroundColor,
                              theme.textColor,
                            ].map((color, idx) => (
                              <div
                                key={idx}
                                className='flex-1 h-4 rounded border border-gray-200 dark:border-gray-600'
                                style={{ backgroundColor: color }}
                                title={color}
                              />
                            ))}
                          </div>

                          <div className='flex items-center justify-between text-xs text-gray-500 dark:text-gray-400'>
                            <span>{theme.fontFamily}</span>
                            <span className='capitalize'>
                              {theme.buttonStyle === "pill"
                                ? t("SETTINGS.PILL")
                                : theme.buttonStyle === "square"
                                  ? t("SETTINGS.SQUARE")
                                  : t("SETTINGS.ROUNDED")}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {storeTheme && (
                  <div className='bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/30 dark:to-purple-900/30 p-6 rounded-2xl border border-indigo-100 dark:border-indigo-800'>
                    <div className='flex items-center justify-between mb-6'>
                      <div>
                        <h4 className='text-xl font-bold text-gray-900 dark:text-white'>
                          {t("SETTINGS.CURRENT_THEME")}
                        </h4>
                        <p className='text-gray-600 dark:text-gray-400'>
                          {storeTheme.themeName}
                        </p>
                      </div>
                      <div className='flex items-center gap-4'>
                        <div className='px-3 py-1 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-700 rounded-lg text-indigo-700 dark:text-indigo-400 font-medium'>
                          {t("COMMONONE.ACTIVE")}
                        </div>
                      </div>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                      <div>
                        <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                          {t("SETTINGS.THEME_DETAILS")}
                        </h5>
                        <div className='space-y-4'>
                          <div>
                            <div className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
                              {t("SETTINGS.FONT_FAMILY")}
                            </div>
                            <div
                              className='text-lg text-gray-900 dark:text-white'
                              style={{ fontFamily: storeTheme.fontFamily }}
                            >
                              {storeTheme.fontFamily}
                            </div>
                          </div>

                          <div>
                            <div className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.COLORS")}
                            </div>
                            <div className='grid grid-cols-2 gap-3'>
                              {[
                                {
                                  label: t("SETTINGS.PRIMARY"),
                                  color: storeTheme.primaryColor,
                                },
                                {
                                  label: t("SETTINGS.BUTTON"),
                                  color: storeTheme.buttonColor,
                                },
                                {
                                  label: t("SETTINGS.BACKGROUND"),
                                  color: storeTheme.backgroundColor,
                                },
                                {
                                  label: t("SETTINGS.TEXT"),
                                  color: storeTheme.textColor,
                                },
                              ].map((item) => (
                                <div
                                  key={item.label}
                                  className='flex items-center gap-2'
                                >
                                  <div
                                    className='w-6 h-6 rounded border border-gray-300 dark:border-gray-600'
                                    style={{ backgroundColor: item.color }}
                                  />
                                  <div>
                                    <div className='text-xs text-gray-600 dark:text-gray-400'>
                                      {item.label}
                                    </div>
                                    <div className='text-sm font-mono text-gray-900 dark:text-gray-100'>
                                      {item.color}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div>
                            <div className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
                              {t("SETTINGS.BUTTON_STYLE")}
                            </div>
                            <div className='capitalize text-gray-900 dark:text-white'>
                              {storeTheme.buttonStyle === "pill"
                                ? t("SETTINGS.PILL")
                                : storeTheme.buttonStyle === "square"
                                  ? t("SETTINGS.SQUARE")
                                  : t("SETTINGS.ROUNDED")}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                          {t("SETTINGS.LIVE_PREVIEW")}
                        </h5>
                        <div className='p-4 bg-white dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-700 shadow-sm'>
                          <div className='flex items-center gap-3 mb-4'>
                            <div
                              className='w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold'
                              style={{
                                backgroundColor: storeTheme.primaryColor,
                              }}
                            >
                              S
                            </div>
                            <div>
                              <div
                                className='font-bold text-gray-900 dark:text-white'
                                style={{
                                  color: storeTheme.headingColor,
                                  fontFamily: storeTheme.fontFamily,
                                }}
                              >
                                {t("SETTINGS.YOUR_STORE")}
                              </div>
                              <div className='text-sm text-gray-600 dark:text-gray-400'>
                                {t("SETTINGS.THEME_PREVIEW")}
                              </div>
                            </div>
                          </div>

                          <div className='space-y-3'>
                            <button
                              className={`w-full py-2.5 font-semibold text-white ${
                                storeTheme.buttonStyle === "pill"
                                  ? "rounded-full"
                                  : storeTheme.buttonStyle === "square"
                                    ? "rounded"
                                    : "rounded-lg"
                              }`}
                              style={{
                                backgroundColor: storeTheme.buttonColor,
                                fontFamily: storeTheme.fontFamily,
                              }}
                            >
                              🛒 {t("SETTINGS.ADD_TO_CART")}
                            </button>

                            <div
                              className='p-3 rounded-lg'
                              style={{
                                backgroundColor:
                                  storeTheme.backgroundColor + "20",
                              }}
                            >
                              <div className='flex justify-between items-center'>
                                <div>
                                  <div
                                    className='font-medium'
                                    style={{ color: storeTheme.headingColor }}
                                  >
                                    {t("SETTINGS.PREMIUM_PRODUCT")}
                                  </div>
                                  <div
                                    className='text-sm'
                                    style={{ color: storeTheme.textColor }}
                                  >
                                    $49.99
                                  </div>
                                </div>
                                <div
                                  className='px-2 py-1 rounded text-xs font-medium'
                                  style={{
                                    backgroundColor:
                                      storeTheme.secondaryColor + "20",
                                    color: storeTheme.secondaryColor,
                                  }}
                                >
                                  {t("SETTINGS.NEW")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-6'>
                    {t("SETTINGS.CUSTOM_THEME_BUILDER")}
                  </h4>

                  <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                    <div className='space-y-6'>
                      <div>
                        <label className='block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2'>
                          {t("SETTINGS.FONT_FAMILY")}
                        </label>
                        <select
                          value={customTheme?.fontFamily || "Inter"}
                          onChange={(e) =>
                            handleCustomThemeChange(
                              "fontFamily",
                              e.target.value,
                            )
                          }
                          className='w-full px-4 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                        >
                          {fontOptions.map((font) => (
                            <option key={font.value} value={font.value}>
                              {font.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className='space-y-4'>
                        {[
                          {
                            key: "primaryColor",
                            label: t("SETTINGS.PRIMARY_COLOR"),
                          },
                          {
                            key: "buttonColor",
                            label: t("SETTINGS.BUTTON_COLOR"),
                          },
                          {
                            key: "backgroundColor",
                            label: t("SETTINGS.BACKGROUND_COLOR"),
                          },
                          { key: "textColor", label: t("SETTINGS.TEXT_COLOR") },
                        ].map((color) => (
                          <div key={color.key}>
                            <label className='block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2'>
                              {color.label}
                            </label>
                            <div className='flex items-center gap-3'>
                              <input
                                type='color'
                                value={customTheme?.[color.key] || "#4f46e5"}
                                onChange={(e) =>
                                  handleCustomThemeChange(
                                    color.key,
                                    e.target.value,
                                  )
                                }
                                className='w-12 h-12 cursor-pointer rounded-lg border border-gray-300 dark:border-gray-600'
                              />
                              <input
                                type='text'
                                value={customTheme?.[color.key] || "#4f46e5"}
                                onChange={(e) =>
                                  handleCustomThemeChange(
                                    color.key,
                                    e.target.value,
                                  )
                                }
                                className='flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg font-mono bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                              />
                            </div>
                          </div>
                        ))}
                      </div>

                      <div>
                        <label className='block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2'>
                          {t("SETTINGS.BUTTON_STYLE")}
                        </label>
                        <div className='flex gap-2'>
                          {buttonStyles.map((style) => (
                            <button
                              key={style.value}
                              onClick={() =>
                                handleCustomThemeChange(
                                  "buttonStyle",
                                  style.value,
                                )
                              }
                              className={`flex-1 py-3 rounded-lg font-medium transition-all ${
                                (customTheme?.buttonStyle || "rounded") ===
                                style.value
                                  ? "bg-indigo-600 text-white shadow-md"
                                  : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                              }`}
                            >
                              {style.name}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div>
                        <label className='block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2'>
                          {t("SETTINGS.THEME_NAME")}
                        </label>
                        <input
                          type='text'
                          value={
                            customTheme?.themeName || t("SETTINGS.CUSTOM_THEME")
                          }
                          onChange={(e) =>
                            handleCustomThemeChange("themeName", e.target.value)
                          }
                          className='w-full px-4 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                          placeholder={t("SETTINGS.ENTER_THEME_NAME")}
                        />
                      </div>

                      <button
                        onClick={() => {
                          if (customTheme) {
                            handleSaveTheme(customTheme);
                            toast.success(t("SETTINGS.CUSTOM_THEME_SAVED"));
                          }
                        }}
                        className='w-full py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-bold hover:from-indigo-700 hover:to-purple-700 transition-colors shadow-md'
                      >
                        {t("SETTINGS.SAVE_CUSTOM_THEME")}
                      </button>
                    </div>

                    <div>
                      <h5 className='text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4'>
                        {t("SETTINGS.LIVE_PREVIEW")}
                      </h5>
                      <div
                        className='p-6 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800'
                        style={{
                          backgroundColor:
                            customTheme?.backgroundColor || "#ffffff",
                        }}
                      >
                        <div className='flex items-center gap-3 mb-6'>
                          <div
                            className='w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold'
                            style={{
                              backgroundColor:
                                customTheme?.primaryColor || "#4f46e5",
                            }}
                          >
                            S
                          </div>
                          <div>
                            <div
                              className='font-bold text-lg'
                              style={{
                                color: customTheme?.headingColor || "#111827",
                                fontFamily: customTheme?.fontFamily || "Inter",
                              }}
                            >
                              {t("SETTINGS.YOUR_STORE")}
                            </div>
                            <div
                              className='text-sm'
                              style={{
                                color: customTheme?.textColor || "#6b7280",
                                fontFamily: customTheme?.fontFamily || "Inter",
                              }}
                            >
                              {t("SETTINGS.PREMIUM_PRODUCTS")}
                            </div>
                          </div>
                        </div>

                        <div className='space-y-3'>
                          <button
                            className={`w-full py-3 font-bold text-white transition-all ${
                              customTheme?.buttonStyle === "pill"
                                ? "rounded-full"
                                : customTheme?.buttonStyle === "square"
                                  ? "rounded-lg"
                                  : "rounded-xl"
                            }`}
                            style={{
                              backgroundColor:
                                customTheme?.buttonColor || "#4f46e5",
                              fontFamily: customTheme?.fontFamily || "Inter",
                            }}
                          >
                            🛒 {t("SETTINGS.ADD_TO_CART")} - $49.99
                          </button>

                          <div className='p-4 rounded-lg border border-gray-200 dark:border-gray-700'>
                            <div className='flex justify-between items-center'>
                              <div>
                                <div
                                  className='font-semibold'
                                  style={{
                                    color:
                                      customTheme?.headingColor || "#111827",
                                    fontFamily:
                                      customTheme?.fontFamily || "Inter",
                                  }}
                                >
                                  {t("SETTINGS.PREMIUM_PRODUCT")}
                                </div>
                                <div
                                  className='text-2xl font-bold'
                                  style={{
                                    color:
                                      customTheme?.primaryColor || "#4f46e5",
                                    fontFamily:
                                      customTheme?.fontFamily || "Inter",
                                  }}
                                >
                                  $99.99
                                </div>
                              </div>
                              <div
                                className='px-3 py-1 rounded-full text-sm font-medium'
                                style={{
                                  backgroundColor:
                                    (customTheme?.secondaryColor || "#10b981") +
                                    "20",
                                  color:
                                    customTheme?.secondaryColor || "#10b981",
                                }}
                              >
                                {t("SETTINGS.HOT_DEAL")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeSettingsTab === "banner" && (
              <div className='space-y-8 animate-fadeIn'>
                <div>
                  <h3 className='text-2xl font-bold text-gray-900 dark:text-white mb-2'>
                    {t("SETTINGS.BANNER_SETTINGS")}
                  </h3>
                  <p className='text-gray-600 dark:text-gray-400'>
                    {t("SETTINGS.BANNER_SETTINGS_DESCRIPTION")}
                  </p>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-6'>
                    {t("SETTINGS.CHOOSE_BANNER_TYPE")}
                  </h4>

                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-8'>
                    {bannerTypeOptions.map((option) => (
                      <div
                        key={option.value}
                        className={`border-2 rounded-xl p-4 cursor-pointer transition-all duration-300 text-center ${
                          bannerType === option.value
                            ? "border-blue-500 dark:border-blue-400 bg-blue-50 dark:bg-blue-900/30 shadow-lg"
                            : "border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 hover:shadow-md"
                        }`}
                        onClick={() => setBannerType(option.value)}
                      >
                        <div className='p-3 bg-blue-100 dark:bg-blue-900/50 rounded-lg mb-3 inline-flex'>
                          <span className='text-blue-600 dark:text-blue-400 text-xl'>
                            {option.icon}
                          </span>
                        </div>
                        <h5 className='font-semibold text-gray-900 dark:text-white'>
                          {option.label}
                        </h5>
                        {bannerType === option.value && (
                          <div className='mt-2 text-sm text-blue-600 dark:text-blue-400 font-medium'>
                            ✓ {t("SETTINGS.SELECTED")}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className='space-y-6'>
                    {bannerType === "image" && (
                      <div>
                        <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                          {t("SETTINGS.UPLOAD_CUSTOM_BANNER")}
                        </h5>
                        <div className='border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-2xl p-8 text-center hover:border-blue-400 dark:hover:border-blue-500 transition-colors'>
                          <MdPhotoSizeSelectActual className='text-gray-400 dark:text-gray-500 text-4xl mx-auto mb-4' />
                          <p className='text-gray-600 dark:text-gray-400 mb-2'>
                            <span className='font-semibold'>
                              {t("SETTINGS.CLICK_TO_UPLOAD")}
                            </span>{" "}
                            {t("SETTINGS.OR_DRAG_DROP")}
                          </p>
                          <p className='text-sm text-gray-500 dark:text-gray-500'>
                            {t("SETTINGS.IMAGE_FORMATS")}
                          </p>
                          <input
                            type='file'
                            className='hidden'
                            id='bannerUpload'
                            accept='image/*'
                            onChange={handleChangeForBanner}
                          />
                          <label
                            htmlFor='bannerUpload'
                            className='inline-block mt-4 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 cursor-pointer'
                          >
                            {t("SETTINGS.CHOOSE_IMAGE")}
                          </label>
                        </div>

                        {selectedBannerFile && (
                          <div className='mt-6'>
                            <h6 className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.SELECTED_IMAGE")}:
                            </h6>
                            <div className='text-sm text-gray-500 dark:text-gray-400 mb-2'>
                              {selectedBannerFile.name}
                            </div>
                            <p className='text-sm text-gray-600 dark:text-gray-400'>
                              {t("SETTINGS.IMAGE_CROP_NOTE")}
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {bannerType === "pre-added" && (
                      <PreAddedImageGallery
                        images={[]}
                        onSelect={handlePreAddedImageSelect}
                        isSelected={selectedPreAddedImage}
                      />
                    )}

                    {bannerType === "color" && (
                      <div>
                        <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                          {t("SETTINGS.CHOOSE_BANNER_COLOR")}
                        </h5>
                        <div className='space-y-4'>
                          <div className='flex items-center gap-4'>
                            <input
                              type='color'
                              value={bannerColor}
                              onChange={(e) => setBannerColor(e.target.value)}
                              className='w-20 h-20 cursor-pointer rounded-xl border-2 border-gray-300 dark:border-gray-600 shadow-sm'
                            />
                            <div className='flex-1'>
                              <input
                                type='text'
                                value={bannerColor}
                                onChange={(e) => setBannerColor(e.target.value)}
                                className='w-full px-4 py-3 text-lg border-2 border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                                placeholder={t("SETTINGS.ENTER_HEX_CODE")}
                              />
                            </div>
                          </div>

                          <div>
                            <p className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.QUICK_COLORS")}:
                            </p>
                            <div className='flex gap-2 flex-wrap'>
                              {[
                                "#4f46e5",
                                "#7c3aed",
                                "#0ea5e9",
                                "#10b981",
                                "#f59e0b",
                                "#ef4444",
                              ].map((color) => (
                                <button
                                  key={color}
                                  onClick={() => setBannerColor(color)}
                                  className='w-10 h-10 rounded-lg border-2 border-gray-300 dark:border-gray-600 hover:scale-110 transition-transform'
                                  style={{ backgroundColor: color }}
                                  title={color}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div>
                      <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                        {t("SETTINGS.LIVE_PREVIEW")}
                      </h5>
                      <div className='relative h-40 rounded-2xl overflow-hidden border-2 border-gray-300 dark:border-gray-600 shadow-lg'>
                        {bannerType === "image" && bannerImagePreview ? (
                          <img
                            src={bannerImagePreview}
                            alt={t("SETTINGS.BANNER_PREVIEW")}
                            className='w-full h-full object-cover'
                          />
                        ) : bannerType === "pre-added" &&
                          selectedPreAddedImage ? (
                          <img
                            src={selectedPreAddedImage.src}
                            alt={t("SETTINGS.BANNER_PREVIEW")}
                            className='w-full h-full object-cover'
                          />
                        ) : bannerType === "color" ? (
                          <div
                            className='w-full h-full'
                            style={{ backgroundColor: bannerColor }}
                          />
                        ) : (
                          <div className='w-full h-full bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900/50 dark:to-purple-900/50 flex items-center justify-center'>
                            <p className='text-gray-500 dark:text-gray-400'>
                              {t("SETTINGS.BANNER_PREVIEW_PLACEHOLDER")}
                            </p>
                          </div>
                        )}
                        <div className='absolute bottom-4 left-4 flex items-center gap-3'>
                          <div className='w-12 h-12 rounded-full border-2 border-white bg-white dark:bg-gray-800 shadow-lg overflow-hidden'>
                            <div className='h-full w-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center'>
                              <MdStore className='text-gray-400 dark:text-gray-500' />
                            </div>
                          </div>
                          <div>
                            <div className='text-white font-bold text-lg drop-shadow-lg'>
                              {t("SETTINGS.YOUR_STORE_NAME")}
                            </div>
                            <div className='text-white/90 text-sm drop-shadow-lg'>
                              {description || t("SETTINGS.STORE_TAGLINE")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {bannerType === "color" && (
                      <div className='pt-4'>
                        <button
                          onClick={handleColorBannerSave}
                          disabled={uploadingBanner}
                          className={`w-full py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition-colors shadow-md ${
                            uploadingBanner
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          {uploadingBanner
                            ? t("COMMONONE.SAVING")
                            : t("SETTINGS.SAVE_COLOR_BANNER")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {storeBanner && (
                  <div className='bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/30 dark:to-purple-900/30 p-6 rounded-2xl border border-blue-100 dark:border-blue-800'>
                    <div className='flex items-center justify-between mb-4'>
                      <h4 className='text-xl font-bold text-gray-900 dark:text-white'>
                        {t("SETTINGS.CURRENT_BANNER")}
                      </h4>
                      <button
                        onClick={() => {
                          if (storeBanner.type === "color") {
                            setBannerType("color");
                            setBannerColor(storeBanner.color);
                          } else if (storeBanner.type === "image") {
                            setBannerType("image");
                          }
                        }}
                        className='px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700'
                      >
                        {t("SETTINGS.EDIT_CURRENT")}
                      </button>
                    </div>

                    <div className='relative h-32 rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600'>
                      {storeBanner.type === "color" ? (
                        <div
                          className='w-full h-full'
                          style={{ backgroundColor: storeBanner.color }}
                        />
                      ) : storeBanner.imageUrl ? (
                        <img
                          src={storeBanner.imageUrl}
                          alt={t("SETTINGS.CURRENT_BANNER")}
                          className='w-full h-full object-cover'
                        />
                      ) : (
                        <div className='w-full h-full bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900/50 dark:to-purple-900/50 flex items-center justify-center'>
                          <p className='text-gray-500 dark:text-gray-400'>
                            {t("SETTINGS.NO_BANNER_SET")}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeSettingsTab === "layout" && (
              <div className='space-y-8 animate-fadeIn'>
                <div>
                  <h3 className='text-2xl font-bold text-gray-900 dark:text-white mb-2'>
                    {t("SETTINGS.LAYOUT_SETTINGS")}
                  </h3>
                  <p className='text-gray-600 dark:text-gray-400'>
                    {t("SETTINGS.LAYOUT_SETTINGS_DESCRIPTION")}
                  </p>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <div className='flex items-center justify-between mb-6'>
                    <div>
                      <h4 className='text-xl font-bold text-gray-900 dark:text-white'>
                        {t("SETTINGS.CURRENT_LAYOUT")}
                      </h4>
                      <p className='text-gray-600 dark:text-gray-400'>
                        {layoutSettings?.type
                          ? layoutSettings.type
                              .split("-")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")
                          : t("SETTINGS.FULLSCREEN_BANNER")}{" "}
                        {t("SETTINGS.LAYOUT_ACTIVE")}
                      </p>
                    </div>
                    <div className='flex items-center gap-4'>
                      <button
                        onClick={handleToggleLandingPage}
                        className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                          layoutSettings?.showLanding !== false
                            ? "bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-400 border border-green-300 dark:border-green-800"
                            : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-400 border border-gray-300 dark:border-gray-600"
                        }`}
                      >
                        {layoutSettings?.showLanding !== false
                          ? t("SETTINGS.LANDING_ENABLED")
                          : t("SETTINGS.LANDING_DISABLED")}
                      </button>
                      <button
                        onClick={handleViewLandingPreview}
                        className='px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700'
                      >
                        {t("SETTINGS.PREVIEW_LANDING")}
                      </button>
                    </div>
                  </div>

                  <div className='mb-6'>
                    <div className='border-b border-gray-200 dark:border-gray-700'>
                      <nav className='-mb-px flex space-x-4 overflow-x-auto'>
                        {[
                          t("SETTINGS.ALL"),
                          t("SETTINGS.BANNER_LAYOUTS"),
                          t("SETTINGS.SIMPLE_LAYOUTS"),
                          t("SETTINGS.DYNAMIC_LAYOUTS"),
                          t("SETTINGS.MODERN_LAYOUTS"),
                          t("SETTINGS.CREATIVE_LAYOUTS"),
                          t("SETTINGS.PRODUCT_LAYOUTS"),
                          t("SETTINGS.NAVIGATION_LAYOUTS"),
                          t("SETTINGS.CONTENT_LAYOUTS"),
                          t("SETTINGS.STORY_LAYOUTS"),
                          t("SETTINGS.SOCIAL_PROOF_LAYOUTS"),
                        ].map((category) => (
                          <button
                            key={category}
                            onClick={() => {
                              setActiveLayoutCategory(
                                category === t("SETTINGS.ALL")
                                  ? null
                                  : category,
                              );
                            }}
                            className={`py-2 px-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                              (category === t("SETTINGS.ALL") &&
                                !activeLayoutCategory) ||
                              activeLayoutCategory === category
                                ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"
                            }`}
                          >
                            {category}
                          </button>
                        ))}
                      </nav>
                    </div>
                  </div>

                  <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-h-[500px] overflow-y-auto p-2'>
                    {layoutOptions
                      .filter(
                        (layout) =>
                          !activeLayoutCategory ||
                          layout.category === activeLayoutCategory,
                      )
                      .map((layout) => (
                        <LayoutPreviewCard
                          key={layout.id}
                          layout={layout.id}
                          isActive={activeLayout === layout.id}
                          onClick={() => handleLayoutSelect(layout.id)}
                        />
                      ))}
                  </div>

                  <div className='mt-6 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg'>
                    <div className='grid grid-cols-3 gap-4 text-sm'>
                      <div className='text-center'>
                        <div className='text-lg font-bold text-gray-900 dark:text-white'>
                          {layoutOptions.length}
                        </div>
                        <div className='text-gray-600 dark:text-gray-400'>
                          {t("SETTINGS.TOTAL_LAYOUTS")}
                        </div>
                      </div>
                      <div className='text-center'>
                        <div className='text-lg font-bold text-gray-900 dark:text-white'>
                          {
                            layoutOptions.filter(
                              (l) =>
                                l.category === t("SETTINGS.MODERN_LAYOUTS"),
                            ).length
                          }
                        </div>
                        <div className='text-gray-600 dark:text-gray-400'>
                          {t("SETTINGS.MODERN_LAYOUTS")}
                        </div>
                      </div>
                      <div className='text-center'>
                        <div className='text-lg font-bold text-gray-900 dark:text-white'>
                          {
                            layoutOptions.filter(
                              (l) =>
                                l.category === t("SETTINGS.DYNAMIC_LAYOUTS"),
                            ).length
                          }
                        </div>
                        <div className='text-gray-600 dark:text-gray-400'>
                          {t("SETTINGS.ANIMATED")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                    {t("SETTINGS.LAYOUT_CUSTOMIZATION")}
                  </h4>

                  <div className='space-y-6'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                      <div className='p-4 border border-gray-200 dark:border-gray-700 rounded-lg'>
                        <label className='flex items-center gap-3 mb-3'>
                          <input
                            type='checkbox'
                            checked={
                              layoutSettings?.layoutSettings?.autoRedirect ||
                              false
                            }
                            onChange={(e) => {
                              setLayoutSettings((prev) => ({
                                ...prev,
                                layoutSettings: {
                                  ...prev?.layoutSettings,
                                  autoRedirect: e.target.checked,
                                },
                              }));
                            }}
                            className='w-5 h-5 rounded border-gray-300 dark:border-gray-600 text-indigo-600 focus:ring-indigo-500'
                          />
                          <div>
                            <span className='font-medium text-gray-700 dark:text-gray-300'>
                              {t("SETTINGS.AUTO_REDIRECT")}
                            </span>
                            <p className='text-sm text-gray-500 dark:text-gray-400 mt-1'>
                              {t("SETTINGS.AUTO_REDIRECT_DESCRIPTION")}
                            </p>
                          </div>
                        </label>

                        {layoutSettings?.layoutSettings?.autoRedirect && (
                          <div className='mt-4 ml-8'>
                            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.REDIRECT_DELAY")}
                            </label>
                            <input
                              type='range'
                              min='0'
                              max='10'
                              value={
                                layoutSettings?.layoutSettings?.redirectDelay ||
                                0
                              }
                              onChange={(e) => {
                                setLayoutSettings((prev) => ({
                                  ...prev,
                                  layoutSettings: {
                                    ...prev?.layoutSettings,
                                    redirectDelay: parseInt(e.target.value),
                                  },
                                }));
                              }}
                              className='w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-indigo-600'
                            />
                            <div className='flex justify-between text-sm text-gray-500 dark:text-gray-400 mt-1'>
                              <span>{t("SETTINGS.IMMEDIATE")}</span>
                              <span>
                                {layoutSettings?.layoutSettings
                                  ?.redirectDelay || 0}
                                s
                              </span>
                              <span>10s</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className='p-4 border border-gray-200 dark:border-gray-700 rounded-lg'>
                        <label className='flex items-center gap-3 mb-3'>
                          <input
                            type='checkbox'
                            checked={
                              layoutSettings?.layoutSettings?.showNavigation !==
                              false
                            }
                            onChange={(e) => {
                              setLayoutSettings((prev) => ({
                                ...prev,
                                layoutSettings: {
                                  ...prev?.layoutSettings,
                                  showNavigation: e.target.checked,
                                },
                              }));
                            }}
                            className='w-5 h-5 rounded border-gray-300 dark:border-gray-600 text-indigo-600 focus:ring-indigo-500'
                          />
                          <div>
                            <span className='font-medium text-gray-700 dark:text-gray-300'>
                              {t("SETTINGS.SHOW_NAVIGATION")}
                            </span>
                            <p className='text-sm text-gray-500 dark:text-gray-400 mt-1'>
                              {t("SETTINGS.SHOW_NAVIGATION_DESCRIPTION")}
                            </p>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className='p-4 border border-gray-200 dark:border-gray-700 rounded-lg'>
                      <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                        {t("SETTINGS.LAYOUT_SPECIFIC_SETTINGS")}
                      </h5>

                      <div className='space-y-4'>
                        {activeLayout === "carousel" && (
                          <div>
                            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.CAROUSEL_SPEED")}
                            </label>
                            <select
                              value={
                                layoutSettings?.layoutSettings?.carouselSpeed ||
                                5000
                              }
                              onChange={(e) => {
                                setLayoutSettings((prev) => ({
                                  ...prev,
                                  layoutSettings: {
                                    ...prev?.layoutSettings,
                                    carouselSpeed: parseInt(e.target.value),
                                  },
                                }));
                              }}
                              className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                            >
                              <option value={3000}>
                                {t("SETTINGS.FAST_3S")}
                              </option>
                              <option value={5000}>
                                {t("SETTINGS.MEDIUM_5S")}
                              </option>
                              <option value={7000}>
                                {t("SETTINGS.SLOW_7S")}
                              </option>
                              <option value={0}>
                                {t("SETTINGS.MANUAL_ONLY")}
                              </option>
                            </select>
                          </div>
                        )}

                        {activeLayout === "animated" && (
                          <div>
                            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.ANIMATION_SPEED")}
                            </label>
                            <select
                              value={
                                layoutSettings?.layoutSettings
                                  ?.animationSpeed || "medium"
                              }
                              onChange={(e) => {
                                setLayoutSettings((prev) => ({
                                  ...prev,
                                  layoutSettings: {
                                    ...prev?.layoutSettings,
                                    animationSpeed: e.target.value,
                                  },
                                }));
                              }}
                              className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                            >
                              <option value='slow'>
                                {t("SETTINGS.SLOW_SMOOTH")}
                              </option>
                              <option value='medium'>
                                {t("SETTINGS.MEDIUM")}
                              </option>
                              <option value='fast'>
                                {t("SETTINGS.FAST_DYNAMIC")}
                              </option>
                            </select>
                          </div>
                        )}

                        {activeLayout === "product-showcase" && (
                          <div>
                            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                              {t("SETTINGS.FEATURED_PRODUCTS_COUNT")}
                            </label>
                            <input
                              type='number'
                              min='1'
                              max='6'
                              value={
                                layoutSettings?.layoutSettings
                                  ?.featuredProductsCount || 3
                              }
                              onChange={(e) => {
                                setLayoutSettings((prev) => ({
                                  ...prev,
                                  layoutSettings: {
                                    ...prev?.layoutSettings,
                                    featuredProductsCount: parseInt(
                                      e.target.value,
                                    ),
                                  },
                                }));
                              }}
                              className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='p-4 border border-gray-200 dark:border-gray-700 rounded-lg'>
                      <div className='flex justify-between items-center mb-4'>
                        <h5 className='text-lg font-semibold text-gray-800 dark:text-gray-200'>
                          {t("SETTINGS.FEATURED_SECTIONS")}
                        </h5>
                        <button
                          type='button'
                          onClick={() => {
                            const updatedSections = [
                              ...(layoutSettings?.layoutSettings
                                ?.featuredSections || []),
                            ];
                            updatedSections.push({
                              title: t("SETTINGS.NEW_SECTION"),
                              description: t("SETTINGS.DESCRIPTION_HERE"),
                              icon: "⭐",
                              enabled: true,
                            });
                            setLayoutSettings((prev) => ({
                              ...prev,
                              layoutSettings: {
                                ...prev?.layoutSettings,
                                featuredSections: updatedSections,
                              },
                            }));
                          }}
                          className='px-3 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700'
                        >
                          + {t("SETTINGS.ADD_SECTION")}
                        </button>
                      </div>

                      <div className='space-y-4'>
                        {layoutSettings?.layoutSettings?.featuredSections?.map(
                          (section, index) => (
                            <div
                              key={index}
                              className='flex items-center justify-between p-4 border border-gray-200 dark:border-gray-700 rounded-lg'
                            >
                              <div className='flex items-center gap-3 flex-1'>
                                <div className='text-2xl'>{section.icon}</div>
                                <div className='flex-1'>
                                  <input
                                    type='text'
                                    value={section.title}
                                    onChange={(e) => {
                                      const updatedSections = [
                                        ...(layoutSettings?.layoutSettings
                                          ?.featuredSections || []),
                                      ];
                                      updatedSections[index].title =
                                        e.target.value;
                                      setLayoutSettings((prev) => ({
                                        ...prev,
                                        layoutSettings: {
                                          ...prev?.layoutSettings,
                                          featuredSections: updatedSections,
                                        },
                                      }));
                                    }}
                                    className='w-full px-2 py-1 border-b border-gray-300 dark:border-gray-600 focus:outline-none focus:border-indigo-500 bg-transparent text-gray-900 dark:text-white'
                                    placeholder={t("SETTINGS.SECTION_TITLE")}
                                  />
                                  <input
                                    type='text'
                                    value={section.description}
                                    onChange={(e) => {
                                      const updatedSections = [
                                        ...(layoutSettings?.layoutSettings
                                          ?.featuredSections || []),
                                      ];
                                      updatedSections[index].description =
                                        e.target.value;
                                      setLayoutSettings((prev) => ({
                                        ...prev,
                                        layoutSettings: {
                                          ...prev?.layoutSettings,
                                          featuredSections: updatedSections,
                                        },
                                      }));
                                    }}
                                    className='w-full px-2 py-1 text-sm text-gray-600 dark:text-gray-400 border-b border-gray-300 dark:border-gray-600 focus:outline-none focus:border-indigo-500 mt-1 bg-transparent'
                                    placeholder={t(
                                      "SETTINGS.SECTION_DESCRIPTION",
                                    )}
                                  />
                                </div>
                              </div>
                              <div className='flex items-center gap-2'>
                                <select
                                  value={section.icon}
                                  onChange={(e) => {
                                    const updatedSections = [
                                      ...(layoutSettings?.layoutSettings
                                        ?.featuredSections || []),
                                    ];
                                    updatedSections[index].icon =
                                      e.target.value;
                                    setLayoutSettings((prev) => ({
                                      ...prev,
                                      layoutSettings: {
                                        ...prev?.layoutSettings,
                                        featuredSections: updatedSections,
                                      },
                                    }));
                                  }}
                                  className='px-2 py-1 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                                >
                                  {FeaturedSectionOptions.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.value} {t(option.translationKey)}
                                    </option>
                                  ))}
                                </select>

                                <label className='relative inline-flex items-center cursor-pointer ml-2'>
                                  <input
                                    type='checkbox'
                                    checked={section.enabled}
                                    onChange={(e) => {
                                      const updatedSections = [
                                        ...(layoutSettings?.layoutSettings
                                          ?.featuredSections || []),
                                      ];
                                      updatedSections[index].enabled =
                                        e.target.checked;
                                      setLayoutSettings((prev) => ({
                                        ...prev,
                                        layoutSettings: {
                                          ...prev?.layoutSettings,
                                          featuredSections: updatedSections,
                                        },
                                      }));
                                    }}
                                    className='sr-only peer'
                                  />
                                  <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                                </label>

                                <button
                                  onClick={() => {
                                    const updatedSections = [
                                      ...(layoutSettings?.layoutSettings
                                        ?.featuredSections || []),
                                    ];
                                    updatedSections.splice(index, 1);
                                    setLayoutSettings((prev) => ({
                                      ...prev,
                                      layoutSettings: {
                                        ...prev?.layoutSettings,
                                        featuredSections: updatedSections,
                                      },
                                    }));
                                  }}
                                  className='p-1 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300'
                                >
                                  <MdClose size={20} />
                                </button>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>

                    <div className='pt-6 border-t border-gray-200 dark:border-gray-700'>
                      <div className='flex gap-4'>
                        <button
                          onClick={handleViewLandingPreview}
                          className='flex-1 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-bold hover:from-indigo-700 hover:to-purple-700 transition-colors shadow-md flex items-center justify-center gap-2'
                        >
                          <MdPreview size={20} />
                          {t("SETTINGS.PREVIEW_LAYOUT_CHANGES")}
                        </button>
                        <button
                          onClick={() => {
                            toast.success(
                              t("SETTINGS.TESTING_LAYOUT", {
                                layout: activeLayout,
                              }),
                            );
                          }}
                          className='px-6 py-3 border border-indigo-600 dark:border-indigo-500 text-indigo-600 dark:text-indigo-400 rounded-xl font-bold hover:bg-indigo-50 dark:hover:bg-indigo-900/30 transition-colors'
                        >
                          {t("SETTINGS.TEST_LAYOUT")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 p-6 rounded-2xl border border-blue-100 dark:border-blue-800'>
                  <h4 className='text-lg font-semibold text-blue-800 dark:text-blue-300 mb-3 flex items-center gap-2'>
                    <MdWidgets className='text-blue-600 dark:text-blue-400' />
                    💡 {t("SETTINGS.LAYOUT_QUICK_ACTIONS")}
                  </h4>
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                    <button
                      onClick={() => handleToggleLandingPage()}
                      className='p-4 bg-white dark:bg-gray-800 border border-blue-200 dark:border-blue-700 rounded-xl text-left hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors hover:shadow-md'
                    >
                      <div className='font-medium text-blue-800 dark:text-blue-300 mb-1 flex items-center gap-2'>
                        {layoutSettings?.showLanding !== false ? (
                          <MdVisibilityOff />
                        ) : (
                          <MdVisibility />
                        )}
                        {layoutSettings?.showLanding !== false
                          ? t("SETTINGS.DISABLE_LANDING")
                          : t("SETTINGS.ENABLE_LANDING")}
                      </div>
                      <div className='text-sm text-blue-600 dark:text-blue-400'>
                        {layoutSettings?.showLanding !== false
                          ? t("SETTINGS.HIDE_LANDING_DESCRIPTION")
                          : t("SETTINGS.SHOW_LANDING_DESCRIPTION")}
                      </div>
                    </button>

                    <button
                      onClick={handleViewStorePreview}
                      className='p-4 bg-white dark:bg-gray-800 border border-blue-200 dark:border-blue-700 rounded-xl text-left hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors hover:shadow-md'
                    >
                      <div className='font-medium text-blue-800 dark:text-blue-300 mb-1 flex items-center gap-2'>
                        <MdStore />
                        {t("SETTINGS.VIEW_STORE_DIRECTLY")}
                      </div>
                      <div className='text-sm text-blue-600 dark:text-blue-400'>
                        {t("SETTINGS.VIEW_STORE_DESCRIPTION")}
                      </div>
                    </button>

                    <button
                      onClick={() => {
                        setActiveLayout("fullscreen-banner");
                        toast.info(t("SETTINGS.RESET_TO_DEFAULT_LAYOUT"));
                      }}
                      className='p-4 bg-white dark:bg-gray-800 border border-blue-200 dark:border-blue-700 rounded-xl text-left hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors hover:shadow-md'
                    >
                      <div className='font-medium text-blue-800 dark:text-blue-300 mb-1 flex items-center gap-2'>
                        <MdRestartAlt />
                        {t("SETTINGS.RESET_TO_DEFAULT")}
                      </div>
                      <div className='text-sm text-blue-600 dark:text-blue-400'>
                        {t("SETTINGS.RESET_LAYOUT_DESCRIPTION")}
                      </div>
                    </button>
                  </div>
                </div>

                <div className='bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm'>
                  <h4 className='text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4'>
                    {t("SETTINGS.LAYOUT_STATISTICS")}
                  </h4>
                  <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                    <div className='text-center p-4 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-lg'>
                      <div className='text-2xl font-bold text-indigo-600 dark:text-indigo-400'>
                        {layoutOptions.length}
                      </div>
                      <div className='text-sm text-gray-600 dark:text-gray-400'>
                        {t("SETTINGS.TOTAL_LAYOUTS")}
                      </div>
                    </div>
                    <div className='text-center p-4 bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/30 dark:to-emerald-900/30 rounded-lg'>
                      <div className='text-2xl font-bold text-emerald-600 dark:text-emerald-400'>
                        {
                          layoutOptions.filter((l) =>
                            [
                              "centered",
                              "glass-morphism",
                              "card-grid",
                            ].includes(l.id),
                          ).length
                        }
                      </div>
                      <div className='text-sm text-gray-600 dark:text-gray-400'>
                        {t("SETTINGS.MODERN_LAYOUTS")}
                      </div>
                    </div>
                    <div className='text-center p-4 bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/30 dark:to-pink-900/30 rounded-lg'>
                      <div className='text-2xl font-bold text-purple-600 dark:text-purple-400'>
                        {
                          layoutOptions.filter((l) =>
                            [
                              "animated",
                              "parallax",
                              "floating-elements",
                            ].includes(l.id),
                          ).length
                        }
                      </div>
                      <div className='text-sm text-gray-600 dark:text-gray-400'>
                        {t("SETTINGS.ANIMATED_LAYOUTS")}
                      </div>
                    </div>
                    <div className='text-center p-4 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/30 dark:to-orange-900/30 rounded-lg'>
                      <div className='text-2xl font-bold text-amber-600 dark:text-amber-400'>
                        {
                          layoutOptions.filter((l) =>
                            ["product-showcase", "testimonial"].includes(l.id),
                          ).length
                        }
                      </div>
                      <div className='text-sm text-gray-600 dark:text-gray-400'>
                        {t("SETTINGS.BUSINESS_FOCUS")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeSettingsTab === "reviews" && (
              <ReviewSettingsPanel
                bussinessUuid={bussinessUuid}
                reviewSettings={reviewSettings}
                setReviewSettings={setReviewSettings}
                loadingReviewSettings={loadingReviewSettings}
                pendingReviewsCount={pendingReviewsCount}
                reviewStats={reviewStats}
                onSave={updateReviewSettings}
                onReset={resetToDefaults}
              />
            )}
          </div>
        </div>
      </ModalComponent>
      <CropModal
        isOpen={isCropModalOpen}
        onClose={() => setIsCropModalOpen(false)}
        imageSrc={bannerImagePreview}
        onCropComplete={handleCropComplete}
        aspectRatio={1521 / 320}
      />
      <QRCodeModal
        open={qrModalOpen}
        onClose={() => setQrModalOpen(false)}
        storeUrl={storeUrl}
        businessName={displayBusinessName || business?.businessName || "Store"}
        businessLogo={business?.businesslogo}
      />
      <div className='flex justify-between items-center px-6 py-4 border-t border-gray-200'>
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
          className='px-3 py-1 bg-gray-300 rounded-sm text-white-700 hover:bg-gray-600 disabled:opacity-50'
        >
          Previous
        </button>
        <span className='text-sm text-gray-500'>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
          className='px-3 py-1 bg-blue-300 rounded-sm text-white-700 hover:bg-blue-600 disabled:opacity-50'
        >
          Next
        </button>
      </div>
    </div>
  );
}